<template>
  <section
    v-loading="loading"
    :element-loading-text="loadingText"
    class="custom-dashboard-view !rounded-xl"
    v-if="this.checkUrlType() == 'SignIn'"
  >
    <div
      class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[1] !pt-3 !rounded-t-xl"
    >
      <div class="flex items-center !gap-1.5">
        <el-button
          @click="goBack"
          size="mini"
          class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        >
          <span>
            <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
          </span>
        </el-button>

        <el-input
          v-model="customDashboardData.name"
          placeholder="Enter dashboard name"
          size="mini"
        ></el-input>
      </div>
      <div
        class="flex items-center justify-start md:!justify-end !gap-3 flex-wrap md:!flex-nowrap flex-1"
      >
        <div style="display: flex; align-items: center">
          <span>Allow change order</span>
          <el-switch
            v-model="customDashboardData.allowUserChangeOrder"
            class="ml-1"
            size="mini"
            active-color="var(--brand-500)"
            inactive-color="var(--black-200)"
          ></el-switch>
        </div>
        <el-button
          style="background: var(--brand-500) !important"
          class="!py-1.5 !px-4 !rounded-sm hover:!bg-brand-500 !border-none !m-0 !h-auto text-xs font-light text-white"
          type="primary"
          @click="saveDashboard"
        >
          Save
        </el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="4" v-if="getIsOpen">
        <div class="left-side-menu">
          <el-row type="flex" justify="center">
            <el-col :xl="24" :lg="24" :md="24">
              <div class="side-menu">
                <el-scrollbar wrap-style="max-height:  calc(100vh - 130px); padding-right: 10px;">
                  <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                    Component Type
                  </h4>
                  <el-select
                    v-model="selectedComponentType"
                    no-data-text="No Components Available"
                    filterable
                    default-first-option
                    class="mb-1 w-full"
                    @change="getComponentInfo"
                  >
                    <el-option
                      v-for="(type, index) of componentTypes"
                      :value="type.value"
                      :key="type.value + index"
                      :label="type.label"
                    >
                      <span style="float: left">{{ type.label }}</span>
                    </el-option>
                  </el-select>
                  <div>
                    <el-checkbox
                      v-if="selectedComponentType == 'CHART'"
                      v-model="customDashboardData.isFromIntegrations"
                      class="mb-1"
                    >
                      Access From Integrations
                    </el-checkbox>
                  </div>
                  <el-checkbox
                    v-if="
                      ![
                        'LOGINS',
                        'ENTITY_VIEW',
                        'SCHEDULING',
                        'GAUGE_CHART',
                        'NOTIFICATIONS',
                      ].includes(selectedComponentType)
                    "
                    v-model="customDashboardData.includeGlobalDateFilter"
                    class="mb-1"
                  >
                    Include Global Date Filter
                  </el-checkbox>
                  <el-checkbox
                    v-if="selectedComponentType == 'TABLE'"
                    v-model="ShowExport"
                    class="mb-1"
                  >
                    Show Export In Table
                  </el-checkbox>
                  <div v-if="selectedComponentType == 'SCHEDULING'">
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Name
                    </h4>
                    <el-input
                      v-model="schedulerComponentName"
                      placeholder="Component Name"
                    ></el-input>
                    <h4
                      class="text-lightGray text-xs 2xl:!text-sm !font-normal mx-0 !mt-3 !mb-1 block"
                    >
                      Scheduling Entity
                    </h4>
                    <el-select
                      class="w-full"
                      v-model="schedulerEntity"
                      no-data-text="No Entities Available"
                      filterable
                      default-first-option
                      clearable
                      @change="
                        (value) => {
                          getEntityFields(value, 'SCHEDULER');
                          fetchSchedulerEntityFilters(value);
                        }
                      "
                    >
                      <el-option
                        v-for="(entity, index) of getAllEntitiesData"
                        :value="entity._id"
                        :key="index"
                        :label="entity.name"
                      >
                        <span style="float: left">{{ entity.name }}</span>
                      </el-option>
                    </el-select>
                    <template v-if="schedulerEntity">
                      <el-checkbox
                        v-if="
                          isEntityDashboard &&
                          getRelationshipEntities.find((e) => e._id == schedulerEntity)
                        "
                        v-model="applyRelationship"
                      >
                        Apply Relationships
                      </el-checkbox>
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                        Task Date
                      </h4>
                      <el-select
                        v-model="schedulerEntityDateField"
                        no-data-text="No Date Fields Available"
                        filterable
                        default-first-option
                      >
                        <el-option
                          v-for="(field, index) of schedulingEntityFields.filter((e) =>
                            ['DATE', 'DATE_TIME', 'DATE_RANGE'].includes(e.inputType)
                          )"
                          :value="field.template_key"
                          :key="index + 'date_field'"
                          :label="field.label"
                        ></el-option>
                      </el-select>
                      <el-checkbox v-model="allowMultipleSlots">
                        allow multiple entity data
                      </el-checkbox>
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                        Resource Entity
                      </h4>
                      <el-select
                        v-model="resourceEntity"
                        no-data-text="No Entities Available"
                        filterable
                        default-first-option
                        @change="
                          (value) =>
                            getEntityFields(
                              schedulingEntityFields.find((e) => e.template_key == value).entity_id,
                              'RESOURCE'
                            )
                        "
                      >
                        <el-option
                          v-for="(field, index) of schedulingEntityFields.filter((e) =>
                            ['ENTITY'].includes(e.inputType)
                          )"
                          :value="field.template_key"
                          :key="index + 'entity_field'"
                          :label="field.label"
                        ></el-option>
                      </el-select>
                      <template v-if="resourceEntity">
                        <h4
                          class="text-lightGray text-xs 2xl:!text-sm !font-normal mx-0 !mt-3 !mb-1 block"
                        >
                          Job Entity
                        </h4>
                        <el-select
                          v-model="jobEntity"
                          no-data-text="No Entities Available"
                          filterable
                          default-first-option
                          @change="
                            (value) =>
                              getEntityFields(
                                schedulingEntityFields.find((e) => e.template_key == value)
                                  .entity_id,
                                'JOB'
                              )
                          "
                        >
                          <el-option
                            v-for="(field, index) of schedulingEntityFields.filter(
                              (e) =>
                                ['ENTITY'].includes(e.inputType) &&
                                e.template_key !== resourceEntity
                            )"
                            :value="field.template_key"
                            :key="index + 'entity_field'"
                            :label="field.label"
                          ></el-option>
                        </el-select>
                      </template>
                      <template v-if="resourceEntity">
                        <h4
                          class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block"
                        >
                          Resource Time
                        </h4>
                        <el-select
                          v-model="resourceEntityTimeField"
                          no-data-text="No Hours Fields Available"
                          filterable
                          default-first-option
                        >
                          <el-option
                            v-for="(field, index) of resourceEntityFields.filter((e) =>
                              ['FORMULA', 'NUMBER'].includes(e.inputType)
                            )"
                            :value="field.template_key"
                            :key="index + 'date_field'"
                            :label="field.label"
                          ></el-option>
                        </el-select>
                      </template>
                      <template v-if="jobEntity">
                        <h4
                          class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block"
                        >
                          Job Time
                        </h4>
                        <el-select
                          v-model="jobEntityTimeField"
                          no-data-text="No Hours Fields Available"
                          filterable
                          default-first-option
                        >
                          <el-option-group label="Job">
                            <el-option
                              v-for="(field, index) of jobEntityFields.filter((e) =>
                                ['FORMULA', 'NUMBER'].includes(e.inputType)
                              )"
                              :value="field.template_key"
                              :key="index + 'date_field'"
                              :label="field.label"
                            ></el-option>
                          </el-option-group>
                          <el-option-group label="Scheduling">
                            <el-option
                              v-for="(field, index) of schedulingEntityFields.filter((e) =>
                                ['FORMULA', 'NUMBER'].includes(e.inputType)
                              )"
                              :value="field.template_key + '@SCHEDULE'"
                              :key="index + 'date_field'"
                              :label="field.label"
                            ></el-option>
                          </el-option-group>
                        </el-select>
                        <h4
                          class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block"
                        >
                          Label For Resource
                        </h4>
                        <el-select
                          v-model="schedulerEntityResourceLabelField"
                          no-data-text="No fields available"
                          filterable
                          default-first-option
                          multiple
                          collapse-tags
                        >
                          <el-option
                            v-for="(field, index) of schedulingEntityFields"
                            :value="field.template_key"
                            :key="index + 'resource_field'"
                            :label="field.label"
                          ></el-option>
                        </el-select>
                        <h4
                          class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block"
                        >
                          Label For Job
                        </h4>
                        <el-select
                          v-model="schedulerEntityJobLabelDateField"
                          no-data-text="No Fields Available"
                          filterable
                          default-first-option
                          multiple
                          collapse-tags
                        >
                          <el-option
                            v-for="(field, index) of schedulingEntityFields"
                            :value="field.template_key"
                            :key="index + 'resource_field'"
                            :label="field.label"
                          ></el-option>
                        </el-select>
                      </template>
                      <template>
                        <h4 class="mt-2">Scheduler Filters</h4>
                        <el-select
                          v-model="selectedSchedulerFilter"
                          v-if="schedulerEntity"
                          filterable
                          placeholder="Select Filters"
                        >
                          <el-option
                            v-for="(filter, index) in schedulerEntityFilters.filter(
                              (f) => !f.parent_filter_id
                            )"
                            :key="index"
                            :label="filter.filter_name"
                            :value="filter._id"
                          />
                        </el-select>
                      </template>
                      <template v-if="schedulerEntity && resourceEntity">
                        <h4
                          class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block"
                        >
                          Scheduling
                          <Samp></Samp>
                          ub-group
                        </h4>
                        <el-select
                          v-model="schedulerEntitySubGroups"
                          no-data-text="No entity Fields Available"
                          filterable
                          default-first-option
                          collapse-tags
                          multiple
                          @change="fetchSubGroupFilters"
                        >
                          <el-option
                            v-for="(field, index) of schedulingEntityFields.filter(
                              (e) =>
                                ['ENTITY'].includes(e.inputType) &&
                                e.template_key !== resourceEntity &&
                                e.template_key !== jobEntity
                            )"
                            :value="field.template_key"
                            :key="index + 'date_field'"
                            :label="field.label"
                          ></el-option>
                        </el-select>
                        <template v-if="schedulerEntitySubGroups.length">
                          <h4
                            class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block"
                          >
                            Divide Sub-groups By
                          </h4>
                          <el-select
                            v-model="schedulerEntitySubGroupsFilters"
                            filterable
                            default-first-option
                            collapse-tags
                            multiple
                          >
                            <el-option-group
                              v-for="entity of schedulerEntitySubGroupsData"
                              :key="entity.entity_id + '_sgf'"
                              :label="entity.label"
                            >
                              <el-option
                                v-for="filter of entity.filters"
                                :key="'_sgf_' + filter._id"
                                :value="entity.key + '@' + filter._id"
                                :label="filter.filter_name"
                              ></el-option>
                            </el-option-group>
                          </el-select>
                        </template>
                      </template>
                      <template v-if="schedulerEntity">
                        <el-link :underline="false" type="primary" @click="openColorRulesDialog">
                          Color Rules
                        </el-link>
                      </template>
                    </template>
                  </div>
                  <div
                    v-else-if="
                      selectedComponentType == 'GAUGE_CHART' ||
                      selectedComponentType == 'NOTIFICATIONS'
                    "
                  >
                    <el-button type="primary" style="width: 100%" @click="configModal = true">
                      Configure
                      <i class="el-icon-setting"></i>
                    </el-button>
                  </div>
                  <div v-else-if="selectedComponentType == 'CALENDAR'">
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Entities
                    </h4>
                    <el-select
                      class="w-full"
                      v-model="selectedCalendarEntities"
                      no-data-text="No Entities Available"
                      filterable
                      default-first-option
                      @change="getEntityDateFields"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="(entity, index) of getAllEntitiesData"
                        :value="entity._id"
                        :key="index"
                        :label="entity.name"
                      >
                        <span style="float: left">{{ entity.name }}</span>
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    v-else-if="
                      selectedComponentType == 'LOGINS' || selectedComponentType === 'ATTENDANCE'
                    "
                  >
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Entities
                    </h4>
                    <el-select
                      class="w-full"
                      v-model="selectedLoginEntity"
                      filterable
                      no-data-text="No Entities available"
                      @change="getLoginEntityDateFields"
                      clearable
                      :disabled="isEntitySelectDisabledForLogin"
                    >
                      <el-option
                        v-for="(entity, index) of getAllEntitiesData"
                        :value="entity._id"
                        :key="index"
                        :label="entity.name"
                      >
                        <span style="float: left">{{ entity.name }}</span>
                      </el-option>
                    </el-select>
                    <div
                      v-if="
                        isEntityDashboard &&
                        !selectedEntityData &&
                        selectedComponentType !== 'SCHEDULING'
                      "
                    >
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                        Relational entities
                      </h4>
                      <el-select
                        class="w-full"
                        placeholder="Relational Entity"
                        v-model="selectedLoginEntityRelationalData"
                        @change="getLoginEntityDateFields"
                        clearable
                        :disabled="isRelationalSelectDisabled"
                      >
                        <el-option
                          v-for="(op, i) in getRelationshipEntities"
                          :key="op._id + i"
                          :value="op._id"
                          :label="op.name"
                        >
                          {{ 'My ' + op.name }}
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div v-else-if="selectedComponentType == 'ENTITY_VIEW'">
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Entity Views
                    </h4>
                    <el-select class="w-full" v-model="selectedEntityView" clearable filterable>
                      <el-option
                        v-for="(view, index) of getAllEntityViews.data"
                        :key="index"
                        :value="view._id"
                        :label="view.name"
                      ></el-option>
                    </el-select>
                    <el-checkbox v-if="selectedEntityView" v-model="isRelationalData">
                      Apply Relationship?
                    </el-checkbox>
                  </div>
                  <div v-else-if="selectedComponentType == 'MULTIPLE_CUSTOM_FILTER'">
                    <h4
                      class="text-lightGray text-xs 2xl:!text-sm !font-normal mx-0 !mt-3 !mb-1 block"
                    >
                      Filter By Field
                    </h4>
                    <el-select
                      v-model="multipleCustomFilterField"
                      filterable
                      default-first-option
                      class="mb-1 w-full"
                      @change="getComponentInfo"
                    >
                      <el-option
                        v-for="(field, index) of getCurrentEntitiesFields"
                        :value="`${field.entity_id}-${field.key}`"
                        :key="field.key + index"
                        :label="`${field.template_name} - ${field.label} `"
                      >
                        <span>{{ field.template_name }} - {{ field.label }}</span>
                      </el-option>
                    </el-select>
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Entities
                    </h4>
                    <el-select
                      class="w-full"
                      v-model="selectedMulCustomFilterEntity"
                      filterable
                      no-data-text="No Entities Available"
                      clearable
                      multiple
                      collapse-tags
                      :disabled="isEntitySelectDisabled"
                    >
                      <el-option
                        v-for="(entity, index) of entityOptions"
                        :value="entity._id"
                        :key="index"
                        :label="entity.name"
                      >
                        <span style="float: left">{{ entity.name }}</span>
                      </el-option>
                    </el-select>
                    <h4
                      class="text-lightGray text-xs 2xl:!text-sm !font-normal mx-0 !mt-3 !mb-1 block"
                    >
                      Dependent On
                    </h4>
                    <el-select
                      class="w-full"
                      v-model="multipleFilterDependency"
                      filterable
                      no-data-text="No Entities Available"
                      clearable
                    >
                      <el-option
                        v-for="(entity, index) of multipleFilterDependencies"
                        :value="entity.key"
                        :key="index"
                        :label="entity.label"
                      ></el-option>
                    </el-select>
                  </div>
                  <div
                    v-else-if="
                      !selectedEntityRelationalData && !customDashboardData.isFromIntegrations
                    "
                  >
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Entities
                    </h4>
                    <el-select
                      class="w-full"
                      v-model="selectedEntityData"
                      no-data-text="No Entities Available"
                      filterable
                      default-first-option
                      @change="getComponentInfo"
                      clearable
                    >
                      <el-option
                        v-for="(entity, index) of selectedComponentType == 'CUSTOM_FILTER'
                          ? getCurrentEntitiesData
                          : getAllEntitiesData"
                        :value="entity._id"
                        :key="index"
                        :label="entity.name"
                      >
                        <span style="float: left">{{ entity.name }}</span>
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    v-if="
                      isEntityDashboard &&
                      !selectedEntityData &&
                      ![
                        'CALENDAR',
                        'LOGINS',
                        'ENTITY_VIEW',
                        'GAUGE_CHART',
                        'NOTIFICATIONS',
                        'SCHEDULING',
                        'ATTENDANCE',
                      ].includes(selectedComponentType)
                    "
                  >
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Relational Entities
                    </h4>
                    <el-select
                      placeholder="Relational Entity"
                      v-model="selectedEntityRelationalData"
                      @change="getComponentInfo"
                      clearable
                    >
                      <el-option
                        v-for="(op, i) in getRelationshipEntities"
                        :key="op._id + i"
                        :value="op._id"
                        :label="op.name"
                      >
                        {{ 'My ' + op.name }}
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    v-if="
                      isEntityDashboard &&
                      !selectedEntityData &&
                      selectedComponentType == 'CALENDAR'
                    "
                  >
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Relational Entities
                    </h4>
                    <el-checkbox
                      v-if="
                        selectedCalendarRelationEntities && selectedCalendarRelationEntities.length
                      "
                      v-model="allowOtherShowData"
                    >
                      Allow Others In Filter
                    </el-checkbox>
                    <el-select
                      class="w-full"
                      placeholder="Relational Entity"
                      v-model="selectedCalendarRelationEntities"
                      clearable
                      @change="getEntityDateFields"
                      multiple
                    >
                      <el-option
                        v-for="(op, i) in getRelationshipEntities"
                        :key="op._id + i"
                        :value="op._id"
                        :label="op.name"
                      >
                        {{ 'My ' + op.name }}
                      </el-option>
                    </el-select>
                    <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block">
                      Nested Relational Entities
                    </h4>
                    <el-select
                      placeholder="Nested Relational Entity"
                      v-model="selectedCalendarNestedRelationEntities"
                      clearable
                      @change="getEntityDateFields"
                      multiple
                    >
                      <el-option
                        v-for="(op, i) in getNestedRelationshipEntities"
                        :key="op.key + i"
                        :value="op.key"
                        :label="op.name"
                      ></el-option>
                    </el-select>
                  </div>
                  <div
                    class="mt-1"
                    v-if="selectedComponentType == 'TABLE' || selectedComponentType == 'CARD'"
                  >
                    <el-select
                      class="w-full"
                      placeholder="Group by"
                      v-model="tableFieldGroupBy"
                      v-if="selectedComponentType == 'TABLE' && selectedEntityData"
                      clearable
                    >
                      <el-option
                        v-for="(field, index) of getTemplateFields"
                        :value="field.key"
                        :key="field.key + index"
                        :label="`${field.template_name} - ${field.label} `"
                      >
                        <span>{{ field.template_name }} - {{ field.label }}</span>
                      </el-option>
                    </el-select>
                    <el-select
                      class="mt-1 w-full"
                      placeholder="Sub Group By"
                      v-model="tableFieldSubGroupBy"
                      v-if="selectedComponentType == 'TABLE' && tableFieldGroupBy"
                      clearable
                      @change="addSubGroupCount"
                    >
                      <el-option
                        v-for="(field, index) of getTemplateFields.filter(
                          (e) => e.input_type != 'MULTI_SELECT' && e.key != tableFieldGroupBy
                        )"
                        :value="field.key"
                        :key="field.key + index"
                        :label="`${field.template_name} - ${field.label} `"
                      >
                        <span>{{ field.template_name }} - {{ field.label }}</span>
                      </el-option>
                    </el-select>
                    <el-select
                      placeholder="Select Options To Group"
                      multiple
                      v-model="tableFieldGroupBySelectedOptions"
                      v-if="tableFieldSubGroupBy"
                      :clearable="true"
                      class="mt-1"
                      collapse-tags
                    >
                      <template v-if="checkFieldType(tableFieldSubGroupBy, 'ENTITY')">
                        <el-option
                          v-for="(data, index) of groupByFieldEntityValues"
                          :key="index + 'entity' + data._id"
                          :value="data._id"
                          :label="getLabel(data, index, groupByFieldEntity)"
                        >
                          <span>{{ getLabel(data, index, groupByFieldEntity) }}</span>
                        </el-option>
                      </template>
                      <template v-else>
                        <el-option
                          v-for="(option, index) of pieChartFieldGroupByOptions"
                          :value="option"
                          :key="index"
                          :label="option"
                        >
                          <span>{{ option }}</span>
                        </el-option>
                      </template>
                    </el-select>
                    <div v-if="tableFieldGroupBy" class="mt-1">
                      <el-tag
                        v-for="(field, index) in tableFieldGroupByFields"
                        :key="index + 'name'"
                        :closable="
                          !tableFieldGroupByFields ||
                          !tableFieldGroupByFields.length ||
                          (tableFieldGroupByFields && tableFieldGroupByFields.length == 1)
                            ? false
                            : true
                        "
                        :type="field && field.sub_group ? 'success' : 'primary'"
                        style="margin-right: 5px; margin-top: 5px"
                      >
                        {{ field.name }}
                      </el-tag>
                      <el-link
                        icon="el-icon-circle-plus-outline"
                        :underline="false"
                        type="primary"
                        @click="openTableColums"
                      ></el-link>
                    </div>
                    <h4
                      class="text-lightGray text-xs 2xl:!text-sm !font-normal mx-0 !mb-1 !mt-2 block"
                    >
                      Filters
                    </h4>
                    <el-input
                      v-model="filterSearchString"
                      placeholder="Search"
                      prefix-icon="el-icon-search"
                      @input="searchFilters()"
                    ></el-input>
                    <h4
                      class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 !mb-1 block !mt-3"
                    >
                      Apply Date Filter On This Field:
                    </h4>
                    <el-select
                      placeholder="Select Date Field"
                      v-model="date_filter_field"
                      default-first-option
                      style="width: 100%"
                      clearable
                    >
                      <el-option
                        v-for="(field, index) of getAllDateFields"
                        :value="field.key"
                        :key="field.key + '_stat_' + index"
                        :label="`${field.template_name} - ${field.label} `"
                      >
                        <span>{{ field.template_name }} - {{ field.label }}</span>
                      </el-option>
                      <el-option value="created_at" label="Created Date">Created Date</el-option>
                      <el-option value="updated_at" label="Updated Date">Updated Date</el-option>
                    </el-select>
                    <el-scrollbar wrap-style="max-height: 300px;">
                      <el-checkbox-group
                        v-model="selectedFilter"
                        class="float-left checkboxOrder"
                        v-if="selectedEntityData || selectedEntityRelationalData"
                      >
                        <el-checkbox
                          v-for="(filter, index) of filters.filter((e) => !e.parent_filter_id)"
                          :key="index"
                          class="mt-1"
                          :label="filter._id"
                        >
                          {{ filter.filter_name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-scrollbar>
                  </div>
                  <div v-else-if="selectedComponentType == 'CUSTOM_FILTER'">
                    <h4
                      class="text-lightGray text-xs 2xl:!text-sm !font-normal mx-0 !mt-2 !mb-1 block"
                    >
                      Filter By Field
                    </h4>
                    <el-select
                      v-model="customFilterField"
                      filterable
                      default-first-option
                      class="mb-1 w-full"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="(field, index) of getTemplateFields"
                        :value="field.key"
                        :key="field.key + index"
                        :label="`${field.template_name} - ${field.label} `"
                      >
                        <span>{{ field.template_name }} - {{ field.label }}</span>
                      </el-option>
                    </el-select>
                  </div>
                  <br />
                  <div v-if="selectedComponentType == 'CALENDAR'">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 block">
                        Select Field
                      </h4>
                      <!-- <el-link
                        icon="el-icon-circle-plus"
                        :disabled="
                          selectedCalendarEntities.length == 0 &&
                          selectedCalendarRelationEntities.length == 0 &&
                          selectedCalendarNestedRelationEntities.length == 0
                        "
                        @click="displayPopup"
                        style="
                          margin-top: 3px;
                          margin-left: 60px;
                          color: var(--brand-500);
                          height: 16px;
                          width: 16px;
                        "
                      ></el-link> -->
                      <img
                        :disabled="
                          selectedCalendarEntities.length == 0 &&
                          selectedCalendarRelationEntities.length == 0 &&
                          selectedCalendarNestedRelationEntities.length == 0
                        "
                        @click="displayPopup"
                        src="@/assets/img/icons/new/addPlus-icon.svg"
                        alt=""
                        class="!size-5 cursor-pointer"
                      />
                    </div>
                    <div>
                      <div v-for="dt in this.calenderDateField" :key="dt.field">
                        <el-tag
                          v-if="dt && dt.field && dt.field.includes('#') && dt.field.split('#')[2]"
                        >
                          {{ dt.field.split('#')[2] }}
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedComponentType == 'LOGINS'">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 block">
                        Map Field
                      </h4>

                      <img
                        :disabled="!selectedLoginEntity && !selectedLoginEntityRelationalData"
                        @click="displayLoginsPopup"
                        src="@/assets/img/icons/new/addPlus-icon.svg"
                        alt=""
                        class="!size-5 cursor-pointer"
                      />
                    </div>
                  </div>
                  <div v-if="selectedComponentType == 'ATTENDANCE'">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 block">
                        Attendance Mapping
                      </h4>

                      <img
                        :disabled="!selectedLoginEntity && !selectedLoginEntityRelationalData"
                        @click="displayNewLoginsPopup"
                        src="@/assets/img/icons/new/addPlus-icon.svg"
                        alt=""
                        class="!size-5 cursor-pointer"
                      />
                    </div>
                    <div>
                      <div v-if="this.loginsDataDetails.length > 0">
                        <el-tag>Data</el-tag>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedComponentType == 'CHART'">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                      <h4 class="text-lightGray text-xs 2xl:!text-sm !font-normal m-0 block">
                        Map Data
                      </h4>

                      <img
                        :disabled="!selectedEntityData && !selectedEntityRelationalData"
                        @click="displayChartsPopup"
                        src="@/assets/img/icons/new/addPlus-icon.svg"
                        alt=""
                        class="!size-5 cursor-pointer"
                      />
                    </div>
                    <div>
                      <div v-if="this.chartType">
                        <el-tag>Data</el-tag>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      isEntityDashboard &&
                      ![
                        'LOGINS',
                        'ENTITY_VIEW',
                        'SCHEDULING',
                        'GAUGE_CHART',
                        'NOTIFICATIONS',
                      ].includes(selectedComponentType) &&
                      selectedEntityRelationalData
                    "
                  >
                    <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">
                      Show data based on :
                    </h4>
                    <el-select
                      v-model="customDashboardData.selectedRelationalFilter"
                      placeholder="Self related Filter"
                    >
                      <el-option value="login_user" label="Login User"></el-option>
                      <el-option
                        v-for="item in getEntityFieldsCurrentEntity"
                        :key="item.entity_id"
                        :label="item.label"
                        :value="item.entity_id + '#' + item.template_key"
                      ></el-option>
                    </el-select>
                  </div>
                </el-scrollbar>
                <div class="!mt-4 !pr-2">
                  <el-button
                    style="background: var(--brand-500) !important"
                    class="!text-white !w-full !py-1.5 !rounded-md !text-xs 2xl:!text-sm !border-none"
                    type="button"
                    @click="insertComponent"
                    :disabled="checkIsDisabled"
                  >
                    Insert
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="getIsOpen ? 20 : 24" class="configuration-cards !mt-3">
        <div>
          <el-row
            v-if="
              (customDashboardData &&
                customDashboardData.allCustomFilters &&
                customDashboardData.allCustomFilters.length) ||
              customDashboardData.includeGlobalDateFilter ||
              customDashboardData.allMulCustomFilters.length ||
              allIntegrationGlobalFilters.length
            "
            style="padding-left: 25px"
            :gutter="30"
          >
            <el-col :span="24">
              <CustomDashboardFilters
                v-if="dateFilter"
                :allDashboardstats="customDashboardData"
                :getAllEntities="getAllEntities"
                :getAllCompanyTemplatesData="{ data: allTemplates }"
                :permittedEntities="permittedEntities"
                :permittedRelatedEntities="permittedRelatedEntities"
                :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                :integrations="integrations"
                @update:selectedDatePicker="updateDateFilter"
                @update:CustomDate="updateCustomDateFilter"
                :allIntegrationGlobalFilters="allIntegrationGlobalFilters"
                :integrationFilters="integration_filters"
              ></CustomDashboardFilters>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="padding-left: 25px">
            <el-col :span="24">
              <CustomDashboardStats
                v-if="componentDataFetched"
                :allDashboardstats="customDashboardData"
                :getRelationshipEntities="getRelationshipEntities"
                :getNestedRelationshipEntities="getNestedRelationshipEntities"
                :isFromApplicationuser="isEntityDashboard"
                :globalVariablesData="globalVariablesData"
                :getAllEntities="getAllEntities"
                :getAllCompanyTemplatesData="{ data: allTemplates }"
                :permittedEntities="permittedEntities"
                :permittedRelatedEntities="permittedRelatedEntities"
                :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                :integrations="integrations"
                @addIntegrationsFilters="checkAndAddGlobalFilters"
                @DateFilterUpdate="DateFilterUpdate"
                @update-dashboardstats="updateDashboardStats"
                :isIntegrationEdit="false"
                :integrationFilters="integration_filters"
              ></CustomDashboardStats>
            </el-col>
          </el-row>
          <div class="wrapper-grid" v-if="!refreshComponents">
            <draggable class="drag-grid" @end="switchPositions">
              <div
                v-for="(component, index) in customDashboardData.allTableComponents"
                :style="
                  expendedIndexs.indexOf(index) !== -1 ||
                  getIsMobile ||
                  component.type == 'SCHEDULING'
                    ? 'grid-column: 1/3;'
                    : ''
                "
                :key="
                  component.entity_id +
                  '_' +
                  (component.filter_id ? component.filter_id : component.pie_chart_field) +
                  index +
                  '_component'
                "
                class="grid-item !bg-card-color shadow-none !rounded-xl !border border-solid !border-page-border overflow-hidden"
              >
                <CustomDashboardTable
                  v-if="component.type == 'TABLE'"
                  :getRelationshipEntities="getRelationshipEntities"
                  :component="component"
                  :key="component.entity_id + '_' + component.filter_id + index + '_table'"
                  :entity_id="component.entity_id"
                  :filter_id="component.filter_id"
                  :index="index"
                  :globalVariablesData="globalVariablesData"
                  :customDashboardData="customDashboardData"
                  :rawData="rawData"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :permittedEntities="permittedEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                  @expendTable="expendTable"
                  @deleteComponent="deleteComponent"
                  @tableUpdate="tableUpdate"
                ></CustomDashboardTable>
                <CustomDashboardPieChart
                  v-else-if="component.type == 'CHART'"
                  :component="component"
                  :hide_options="false"
                  :hide_expend="false"
                  :index="index"
                  :customDashboardData="customDashboardData"
                  :globalVariablesData="globalVariablesData"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :permittedEntities="permittedEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                  @expendTable="expendTable"
                  @deleteComponent="deleteComponent"
                  @tableUpdate="tableUpdate"
                  :getRelationshipEntities="getRelationshipEntities"
                  @updateChartComponent="updateChartComponent"
                  :integrations="integrations"
                  :integrationFilters="integration_filters"
                ></CustomDashboardPieChart>
                <CustomDashboardCalendar
                  v-if="component.type == 'CALENDAR'"
                  :component="component"
                  :getNestedRelationshipEntities="getNestedRelationshipEntities"
                  :index="index"
                  :customDashboard="customDashboardData"
                  :globalVariablesData="globalVariablesData"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :permittedEntities="permittedEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                  @expendTable="expendTable"
                  @deleteComponent="deleteComponent"
                  @tableUpdate="tableUpdate"
                ></CustomDashboardCalendar>
                <CustomDashboardCard
                  v-else-if="component.type == 'CARD'"
                  :component="component"
                  :key="component.entity_id + '_' + component.filter_id + index + '_card'"
                  :entity_id="component.entity_id"
                  :filter_id="component.filter_id"
                  :index="index"
                  :globalVariablesData="globalVariablesData"
                  :customDashboardData="customDashboardData"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :permittedEntities="permittedEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                ></CustomDashboardCard>
                <CustomDashboardLogins
                  v-else-if="component.type == 'LOGINS' || component.type == 'ATTENDANCE'"
                  :component="component"
                  :index="index"
                  :customDashboard="customDashboardData"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :permittedEntities="permittedEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                  @expendTable="expendTable"
                  @deleteComponent="deleteComponent"
                  @tableUpdate="tableUpdate"
                ></CustomDashboardLogins>
                <EntityViews
                  v-else-if="component.type == 'ENTITY_VIEW'"
                  :entityViewId="component.entity_view_id"
                  :fromCustomDashboard="true"
                  :index="index"
                  :component="component"
                  :customDashboardData="customDashboardData"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :permittedEntities="permittedEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                  @deleteComponent="deleteComponent"
                  @expendTable="expendTable"
                  @viewUpdate="tableUpdate"
                  :hide_options="false"
                ></EntityViews>
                <SchedulingEntity
                  v-else-if="component.type == 'SCHEDULING'"
                  :getAllEntities="getAllEntities"
                  :getAllCompanyTemplatesData="allTemplates"
                  :permittedEntities="permittedEntities"
                  :globalVariablesData="globalVariablesData"
                  :customDashboardData="customDashboardData"
                  :getRelationshipEntities="getRelationshipEntities"
                  :permittedRelatedEntities="permittedRelatedEntities"
                  :permittedNestedRelatedEntities="permittedNestedRelatedEntities"
                  :component="component"
                  :index="index"
                  :hide_options="false"
                  :isFromApplicationuser="isEntityDashboard"
                  @deleteComponent="deleteComponent"
                  @tableUpdate="tableUpdate"
                ></SchedulingEntity>
                <CustomDashboardGauge
                  v-else-if="component.type == 'GAUGE_CHART'"
                  :component="component"
                  :index="index"
                  :getAllCompanyTemplatesData="{ data: allTemplates }"
                  :hide_options="false"
                  @editComponent="editGauge"
                  @deleteComponent="deleteComponent"
                  @expendTable="expendTable"
                ></CustomDashboardGauge>
                <CustomDashboardNotifications
                  v-else-if="component.type == 'NOTIFICATIONS'"
                  :component="component"
                  :index="index"
                  :hide_options="false"
                  @deleteComponent="deleteComponent"
                  @editComponent="editNotifications"
                ></CustomDashboardNotifications>
                <!-- <CustomDashboardGanttChart
                v-else-if="component.type == 'GANTT_CHART'"
                :component="component"
                  :index="index"
                  :hide_options="false"
                  @deleteComponent="deleteComponent"
                  @editComponent="editNotifications">
                </CustomDashboardGanttChart> -->
              </div>
            </draggable>
          </div>
        </div>
      </el-col>
    </el-row>
    <dialog-component
      :visible="goBackToCustom"
      :title="'Warning'"
      :containerWidth="'35%'"
      @before-close="backToCustom"
    >
      <div class="popUp-content m-tb-5">
        <span>
          <h5>It looks like you have been modifying something</h5>
        </span>
        <span>If you leave before updating, your changes will be lost.</span>
      </div>
      <span slot="footer">
        <el-button
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800 !mr-1"
          type="plain"
          @click="goBackToCustom = false"
        >
          Cancel
        </el-button>
        <el-button type="primary" @click="backToCustom">Confirm</el-button>
      </span>
    </dialog-component>

    <dialog-component
      :title="'Calendar Component'"
      :visible="centerDialogVisible"
      @before-close="CenterDialogVisibleClose"
      :containerWidth="'82%'"
      :containerMinHeight="'20%'"
      draggable
    >
      <div v-if="tableData" class="mt-10 mr-10">
        <label>Component name</label>
        <span class="text-danger">*</span>
        <el-input v-model="calendarName" placeholder="Enter component name" class="mb-1"></el-input>
      </div>
      <el-scrollbar class="scrollbar-container">
        <div class="scrollable-table-container mr-10">
          <el-table :data="tableData" border>
            <el-table-column prop="Contact Type" label="Fields" width="180">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.field"
                  filterable
                  default-first-option
                  class="mb-1 mt-1"
                  @change="getEntityFilters"
                  clearable
                >
                  <el-option
                    v-for="(field, index) of getTemplateDateFields"
                    :value="field.key"
                    :key="field.key + index"
                    :label="`${field.entity_name} - ${field.template_name} - ${field.label} `"
                    :disabled="(tableData || []).findIndex((ex) => ex.field == field.key) != -1"
                  >
                    <span>
                      {{ field.entity_name }} - {{ field.template_name }} -
                      {{ field.label }}
                    </span>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column prop="Custom Message" label="Custom Message *" width="250">
              <template slot-scope="scope">
                <div
                  v-if="
                    scope.row.field &&
                    scope.row.field.includes('#') &&
                    scope.row.field.split('#')[0]
                  "
                >
                  <CustomEntityMention
                    :entity_id="scope.row.field.split('#')[0]"
                    :data="scope.row"
                  ></CustomEntityMention>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="Filter" label="Filter">
              <template slot-scope="scope">
                <el-select
                  clearable
                  v-model="scope.row.filter"
                  placeholder="Select filter"
                  v-if="
                    scope.row.field &&
                    scope.row.field.includes('#') &&
                    scope.row.field.split('#')[0]
                  "
                >
                  <el-option
                    v-for="(op, i) of (
                      getCurrenEntityFilter(scope.row.field.split('#')[0]) || []
                    ).filter((e) => !e.parent_filter_id)"
                    :key="i + op._id"
                    :value="op._id"
                    :label="op.filter_name"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column prop="show every year" label="Show every year">
              <template slot-scope="scope">
                <div class="d-flex">
                  <div>
                    <el-checkbox
                      class="mr-2"
                      type="textarea"
                      v-model="scope.row.show_every_year"
                    ></el-checkbox>

                    <el-link
                      class="mr-2"
                      @click.native.prevent="deleteRow(scope.$index, tableData)"
                      type="danger"
                      icon="el-icon-delete"
                    ></el-link>
                  </div>
                  <div>
                    <el-color-picker size="mini" v-model="scope.row.color"></el-color-picker>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Show background color">
              <template slot-scope="scope">
                <div>
                  <el-checkbox type="textarea" v-model="scope.row.applyBackground"></el-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Show formbuilder data">
              <template slot-scope="scope">
                <div>
                  <el-checkbox
                    v-if="isPresentInFormbuilder(scope.row)"
                    type="textarea"
                    v-model="scope.row.show_formbuilder_data"
                  ></el-checkbox>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
      <br />
      <br />
      <div class="calendar-header mb-05">
        <div class="child-a">
          <p>
            <b>HINT:</b>
            Type @ to insert entity field
          </p>
        </div>
        <div class="child-a mr-2">
          <el-link
            icon="el-icon-circle-plus"
            type="primary"
            @click="addNewRow"
            style="float: right"
          >
            Add
          </el-link>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="resetEventModal"
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800 !mr-1"
        >
          Cancel
        </el-button>
        <el-button type="primary" @click="insertCalendarFields" :disabled="disableSave">
          Save
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :title="'Add table columns'"
      :visible="openTableColumsModal"
      :containerWidth="'50%'"
      @before-close="openTableColumsModalClose"
      draggable
    >
      <el-row>
        <el-link
          icon="el-icon-circle-plus"
          type="primary"
          @click="addNewColumn"
          style="float: right"
          :underline="false"
        >
          Add
        </el-link>
      </el-row>
      <el-row>
        <el-scrollbar wrap-style="max-height: 250px; width: 100% !important;">
          <el-table :data="tableFieldGroupByFieldsModal" border>
            <el-table-column
              prop="Group"
              label="Is sub group?"
              width="180"
              v-if="tableFieldSubGroupBy"
            >
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.sub_group" :disabled="scope.row.key ? true : false">
                  Is sub group?
                </el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="Column" label="Column" width="180">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.key"
                  placeholder="Table columns"
                  v-if="tableFieldGroupBy"
                  clearable
                  @change="fillLabel(scope.row.key, scope.$index)"
                >
                  <el-option
                    label="Count"
                    value="count"
                    :disabled="
                      tableFieldGroupByFieldsModal.find(
                        (e) => e.key == 'count' && scope.row.sub_group == e.sub_group
                      )
                        ? true
                        : false
                    "
                  ></el-option>
                  <el-option-group label="Sum">
                    <el-option
                      v-for="(field, index) of getTotalFields"
                      :value="field.key"
                      :key="field.key + index"
                      :label="`${field.template_name} - ${field.label} `"
                      :disabled="
                        tableFieldGroupByFieldsModal.find(
                          (e) => e.key == 'count' && scope.row.sub_group == e.sub_group
                        )
                          ? true
                          : false
                      "
                    >
                      <span>{{ field.template_name }} - {{ field.label }}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="Contact Type" label="Column name" width="180">
              <template slot-scope="scope">
                <el-input placeholder="Enter name" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Actions" label="Actions" width="180">
              <template slot-scope="scope">
                <el-link
                  @click.native.prevent="deleteRow(scope.$index, tableFieldGroupByFieldsModal)"
                  type="danger"
                  icon="el-icon-delete"
                  :underline="false"
                ></el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="openTableColumsModal = false"
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800"
        >
          Cancel
        </el-button>
        <el-button
          class="!ml-1.5"
          type="primary"
          @click="saveTableGroupBy"
          :disabled="checkTableGroupByField"
        >
          Save
        </el-button>
      </span>
    </dialog-component>

    <dialog-component
      :title="'Logins Component'"
      :visible="centerLoginsDialogVisible"
      @before-close="loginPopUpClose"
      width="70%"
      draggable
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <label>Start Time</label>
          <el-input
            v-model="start_button"
            placeholder="Enter component name"
            class="mb-1"
          ></el-input>
        </el-col>
        <el-col :span="12">
          <label>End Time</label>
          <el-input v-model="end_button" placeholder="Enter component name" class="mb-1"></el-input>
        </el-col>
      </el-row>
      <div v-if="isEntityDashboard">
        <label>Filter</label>
        <br />
        <el-select
          placeholder="Select filter"
          clearable
          v-model="loginFilter"
          class="mb-1"
          style="width: 600px"
        >
          <el-option
            v-for="fl in loginEntityFilters.filter((e) => !e.parent_filter_id)"
            :key="fl._id"
            :value="fl._id"
            :label="fl.filter_name"
          ></el-option>
        </el-select>
      </div>
      <el-checkbox v-model="swipeConfig.show">Display View Swipes</el-checkbox>
      <el-checkbox v-model="timeDuration">Display Timer</el-checkbox>
      <br />
      <el-input
        v-if="swipeConfig.show"
        v-model="swipeConfig.label"
        placeholder="Enter swipe label"
        style="margin-top: 10px"
      ></el-input>
      <br />
      <el-table :data="info" border>
        <el-table-column label="Component Info">
          <template slot-scope="scope">
            {{ scope.row.component }}
          </template>
        </el-table-column>
        <el-table-column prop="Contact Type" label="Fields" width="250">
          <template slot-scope="scope">
            <el-select v-model="scope.row.field" size="mini" clearable>
              <el-option
                v-for="(field, i) of allDateTimeFields"
                :key="field + i"
                :value="field.template_key"
                :label="field.label"
                :disabled="isFieldDisabled(field)"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="loginLogoutDropdownData" border style="margin-top: 20px">
        <el-table-column label="Dropdown Field" width="180">
          <template slot-scope="scope">
            {{ scope.row.component }}
          </template>
        </el-table-column>

        <el-table-column label="Select Fields">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.fields"
              size="mini"
              multiple
              clearable
              collapse-tags
              placeholder="Select fields"
              style="width: 100%"
            >
              <el-option
                v-for="field in allEntityFields"
                :key="field.template_key"
                :value="field.template_key"
                :label="field.label"
                :disabled="isFieldDisabled(field)"
              />
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-row>
          <!-- <el-checkbox   class="mb-1 mt-1 " v-model="isDropdownVisible">Add Geo Location Fields</el-checkbox> -->
          <el-checkbox class="mb-1 mt-1" v-model="isGeoFenceRequired">Setup Geofence</el-checkbox>
          <el-row v-if="isDropdownVisible" :gutter="20" class="mb-1 mt-1">
            <el-col :span="12">
              <div style="display: flex; align-items: center">
                <label>Login Location</label>
              </div>
              <el-select v-model="selectedLoginLocation" placeholder="Select Login Location">
                <el-option
                  v-for="(field, i) in allLocationFields"
                  :key="field + i"
                  :value="field.template_key"
                  :label="field.label"
                  :disabled="field.template_key === selectedLogoutLocation"
                ></el-option>
              </el-select>
            </el-col>

            <el-col :span="12">
              <div style="display: flex; align-items: center">
                <label>Logout Location</label>
              </div>
              <el-select v-model="selectedLogoutLocation" placeholder="Select Logout Location">
                <el-option
                  v-for="(field, i) in allLocationFields"
                  :key="field + i"
                  :value="field.template_key"
                  :label="field.label"
                  :disabled="field.template_key === selectedLoginLocation"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row v-if="isGeoFenceRequired" :gutter="20">
            <el-col :span="12">
              <label>Enter Fence Radius</label>
              <br />
              <el-input-number v-model="geoFenceRadius" :min="1" :max="50000"></el-input-number>
            </el-col>
            <el-col :span="8">
              <label>Enter Fence Center Address (or) co-ordinates</label>
              <el-input
                v-model="geoFenceCoordinates"
                placeholder="Enter Address"
                @change="getEpicenter"
              ></el-input>
            </el-col>
          </el-row>
        </el-row>
        <!-- <el-col   :span="12" v-if="displayAutoLogout">
              <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <div style="display: flex; align-items: center;">
                <label>Auto logout </label>
        </div>
        <el-input
          v-model="auto_logout"
          type ="number"
          placeholder="Enter number "
          class="mb-1"
          style="width:95% ;"
        ></el-input>
              </div>
            </el-col> -->
        <el-col :span="12">
          <div
            style="display: flex; flex-direction: column; align-items: flex-start"
            v-if="isEntityDashboard && !selectedEntityData"
          >
            <div style="display: flex; align-items: center">
              <label>Select User Field</label>
            </div>
            <el-select v-model="user_field" clearable style="width: 95%">
              <el-option
                v-for="(field, i) of entityField"
                :key="field + i"
                :value="field.template_key"
                :label="field.label"
              ></el-option>
            </el-select>
          </div>
          <div v-if="!isEntityDashboard">
            <div style="display: flex; align-items: center">
              <label>Select Field</label>
              <el-popover
                placement="top-start"
                trigger="hover"
                content="add singleline field to store user data "
              >
                <i class="el-icon-info" slot="reference"></i>
              </el-popover>
            </div>
            <el-select v-model="companyuser_field" clearable style="width: 95%">
              <el-option
                v-for="(field, i) of textField"
                :key="field + i"
                :value="field.template_key"
                :label="field.label"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div v-if="shouldDisplayInput">
            <div style="display: flex; align-items: center">
              <label>No. of days</label>
            </div>
            <el-input
              v-model="Days"
              type="number"
              placeholder="Enter number of days"
              class="mb-1"
              style="width: 95%"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="centerLoginsDialogVisible = false"
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800 !mr-1"
        >
          Cancel
        </el-button>
        <el-button type="primary" @click="saveLoginsData" :disabled="disableloginSave">
          Save
        </el-button>
      </span>
    </dialog-component>

    <!--- Attendance Fields Mapping  Start ---->

    <dialog-component
      :title="'Attendance Configuration'"
      :visible="loginsDialogVisible"
      @before-close="loginPopUpClose"
      width="80%"
      draggable
    >
      <el-card>
        <el-row :gutter="20">
          <el-col :span="12">
            <label>Start Time</label>
            <el-input
              v-model="attendance.start_button"
              placeholder="Starting Label"
              class="mb-1"
            ></el-input>
          </el-col>
          <el-col :span="12">
            <label>End Time</label>
            <el-input
              v-model="attendance.end_button"
              placeholder="Closing Label"
              class="mb-1"
            ></el-input>
          </el-col>
        </el-row>

        <div v-if="isEntityDashboard">
          <label>Filter</label>
          <br />
          <el-select
            placeholder="Select filter"
            clearable
            v-model="attendance.loginFilter"
            class="mb-1"
            style="width: 600px"
          >
            <el-option
              v-for="fl in loginEntityFilters.filter((e) => !e.parent_filter_id)"
              :key="fl._id"
              :value="fl._id"
              :label="fl.filter_name"
            ></el-option>
          </el-select>
        </div>
        <el-table :data="attendance.new_attendance" border>
          <el-table-column label="Component Info">
            <template slot-scope="scope">
              {{ scope.row.component }}
            </template>
          </el-table-column>
          <el-table-column prop="Contact Type" label="Fields" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.field" size="mini" clearable>
                <template v-if="scope.row.type === 'TEXT'">
                  <el-option
                    v-for="(field, i) of textField"
                    :key="field + i"
                    :value="field.template_key"
                    :label="field.label"
                    :disabled="isFieldDisabled(field)"
                  ></el-option>
                </template>
                <template v-else-if="scope.row.type === 'DATE' || scope.row.type === 'SELECT'">
                  <el-option
                    v-for="(field, i) of allDateTimeFields"
                    :key="field + i"
                    :value="field.template_key"
                    :label="field.label"
                    :disabled="isFieldDisabled(field)"
                  ></el-option>
                </template>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-row>
            <!-- <el-checkbox   class="mb-1 mt-1 " v-model="isDropdownVisible">Add Geo Location Fields</el-checkbox> -->
            <el-checkbox class="mb-1 mt-1" v-model="attendance.isGeoFenceRequired">
              Setup Geo fence
            </el-checkbox>
            <el-row v-if="attendance.isDropdownVisible" :gutter="20" class="mb-1 mt-1">
              <el-col :span="12">
                <div style="display: flex; align-items: center">
                  <label>Login Location</label>
                </div>
                <el-select
                  v-model="attendance.selectedLoginLocation"
                  placeholder="Select Login Location"
                >
                  <el-option
                    v-for="(field, i) in allLocationFields"
                    :key="field + i"
                    :value="field.template_key"
                    :label="field.label"
                    :disabled="field.template_key === attendance.selectedLogoutLocation"
                  ></el-option>
                </el-select>
              </el-col>

              <el-col :span="12">
                <div style="display: flex; align-items: center">
                  <label>Logout Location</label>
                </div>
                <el-select
                  v-model="attendance.selectedLogoutLocation"
                  placeholder="Select Logout Location"
                >
                  <el-option
                    v-for="(field, i) in allLocationFields"
                    :key="field + i"
                    :value="field.template_key"
                    :label="field.label"
                    :disabled="field.template_key === attendance.selectedLoginLocation"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row v-if="attendance.isGeoFenceRequired" :gutter="20">
              <el-col :span="12">
                <label>Enter Fence Radius</label>
                <br />
                <el-input-number
                  v-model="attendance.geoFenceRadius"
                  :min="1"
                  :max="50000"
                ></el-input-number>
              </el-col>
              <el-col :span="8">
                <label>Enter Fence Center Address (or) co-ordinates</label>
                <el-input
                  v-model="attendance.geoFenceCoordinates"
                  placeholder="Enter Address"
                  @change="getEpicenter"
                ></el-input>
              </el-col>
            </el-row>
          </el-row>
          <!-- <el-col   :span="12" v-if="displayAutoLogout">
              <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <div style="display: flex; align-items: center;">
                <label>Auto logout </label>
        </div>
        <el-input
          v-model="auto_logout"
          type ="number"
          placeholder="Enter number "
          class="mb-1"
          style="width:95% ;"
        ></el-input>
              </div>
            </el-col> -->
          <el-col :span="12">
            <div
              style="display: flex; flex-direction: column; align-items: flex-start"
              v-if="isEntityDashboard && !selectedEntityData"
            >
              <div style="display: flex; align-items: center">
                <label>Select User Field</label>
              </div>
              <el-select v-model="attendance.user_field" clearable style="width: 95%">
                <el-option
                  v-for="(field, i) of entityField"
                  :key="field + i"
                  :value="field.template_key"
                  :label="field.label"
                ></el-option>
              </el-select>
            </div>
            <div v-if="!isEntityDashboard">
              <div style="display: flex; align-items: center">
                <label>Select Field</label>
                <el-popover
                  placement="top-start"
                  trigger="hover"
                  content="add singleline field to store user data "
                >
                  <i class="el-icon-info" slot="reference"></i>
                </el-popover>
              </div>
              <el-select v-model="attendance.companyuser_field" clearable style="width: 95%">
                <el-option
                  v-for="(field, i) of textField"
                  :key="field + i"
                  :value="field.template_key"
                  :label="field.label"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div v-if="shouldDisplayInput">
              <div style="display: flex; align-items: center">
                <label>No. of days</label>
              </div>
              <el-input
                v-model="attendance.Days"
                type="number"
                placeholder="Enter number of days"
                class="mb-1"
                style="width: 95%"
              ></el-input>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="loginsDialogVisible = false"
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800 !mr-1"
        >
          Cancel
        </el-button>
        <el-button type="primary" @click="saveAttendanceData" :disabled="validateNewLogin">
          Save
        </el-button>
      </span>
    </dialog-component>

    <!--- Attendance Fields mapping end -->

    <dialog-component
      :title="'Charts Component'"
      :visible="centerChartsDialogVisible"
      @before-close="chartsPopUpClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :containerWidth="'50%'"
      class="chart-component-sty"
    >
      <div v-loading="loading" element-loading-text="Please wait, Generating chart...">
        <div class="!w-full !overflow-x-hidden">
          <div style="display: flex; align-items: center; justify-content: space-between">
            <div>
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Stat Icon</h4>
              <el-button
                type="text"
                class="text-center ml-1"
                @click="iconPickerdialogVisible = true"
              >
                <div class="menu-icon">
                  <icons
                    style="color: var(--brand-500)"
                    :iconName="this.chartIcon ? this.chartIcon : 'dashboard'"
                  ></icons>
                </div>
              </el-button>
            </div>
            <div class="try-ai-container mt-1 mr-1">
              <span class="ai-icon" @click="showAiInput = !showAiInput">
                <div class="ai-icon-content">
                  <icons
                    :iconName="'TryUsingAI'"
                    style="color: var(--brand-500) !important; fill: var(--brand-500) !important"
                  ></icons>
                  <span class="ai-text">Try Using AI</span>
                </div>
              </span>
            </div>
          </div>
          <form @submit.prevent="fetchChartData">
            <div v-if="showAiInput" class="mb-1 mt-1">
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">
                Enter your prompt to build chart
              </h4>
              <div class="d-flex">
                <el-input
                  v-model="userPrompt"
                  placeholder="Enter your AI prompt..."
                  size="small"
                  clearable
                  @keyup.enter="fetchChartData"
                ></el-input>
                <el-button
                  slot="append"
                  icon="el-icon-s-promotion"
                  size="small"
                  class="rotate-icon"
                  @click="fetchChartData"
                ></el-button>
              </div>
            </div>
          </form>

          <div class="mt-1 mr-1 mb-1">
            <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">
              Enter Component Name:
            </h4>
            <el-input v-model="chartComponentName"></el-input>
          </div>
          <div class="mt-1 mr-1 mb-1">
            <h4>Enter Description</h4>
            <el-input
              v-model="chartDescription"
              placeholder="Enter Description"
              type="textarea"
            ></el-input>
          </div>
          <div class="!mb-4">
            <el-checkbox v-model="isCustomization">Select Customization</el-checkbox>
            <div v-if="isCustomization" style="margin-top: 10px">
              <el-select
                v-model="selectedCustomization"
                placeholder="Select Customization"
                filterable
                clearable
                :loading="loading"
                style="width: 100%"
              >
                <el-option
                  v-for="item in customizationOptions"
                  :key="item._id"
                  :label="item.label"
                  :value="item._id"
                />
              </el-select>
            </div>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Chart type</h4>
              <el-select v-model="chartType" filterable default-first-option class="mb-1 !w-full">
                <el-option
                  v-for="(field, index) of chartTypes"
                  :value="field.value"
                  :key="field.value + index"
                  :label="field.label"
                >
                  <span>{{ field.label }}</span>
                </el-option>
              </el-select>
              <div v-if="chartType === 'BAR'" class="!mt-4 !mb-3">
                <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">
                  Bar Orientation
                </h4>
                <el-radio-group v-model="barOrientation">
                  <el-radio-button label="vertical">Vertical</el-radio-button>
                  <el-radio-button label="horizontal">Horizontal</el-radio-button>
                </el-radio-group>
              </div>
            </el-col>
            <el-col :span="12">
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Select field</h4>
              <el-select
                v-model="pieChartField"
                filterable
                default-first-option
                class="mb-1 !w-full"
                @change="fetchFieldOptionsForChart(pieChartField)"
              >
                <el-option
                  v-for="(field, index) of getTemplateFields"
                  :value="field.key"
                  :key="field.key + index"
                  :label="`${field.template_name} - ${field.label} `"
                >
                  <span>{{ field.template_name }} - {{ field.label }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <h4
                v-if="pieChartField"
                class="!text-xs 2xl:!text-sm !text-black-950 !font-normal !mb-1"
              >
                Select Options
              </h4>
              <el-select
                placeholder="Select options for chart"
                multiple
                v-model="pieChartFieldOptions"
                v-if="pieChartField"
                :clearable="true"
                collapse-tags
                class="mb-1 !w-full"
                @change="chartType === 'BAR' ? optionsChanged : () => {}"
              >
                <template v-if="checkFieldType(pieChartField, 'ENTITY')">
                  <el-option
                    v-for="(data, index) of pieChartFieldEntityValues"
                    :key="index + 'entity' + data._id"
                    :value="data._id"
                    :label="getLabel(data, index, pieChartFieldEntity)"
                  >
                    <span>{{ getLabel(data, index, pieChartFieldEntity) }}</span>
                  </el-option>
                </template>
                <template v-else>
                  <el-option
                    v-for="(option, index) of pieChartFieldSelectOptions"
                    :value="option"
                    :key="index"
                    :label="option"
                  >
                    <span>{{ option }}</span>
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="12">
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Filter</h4>
              <!-- chartFilters -->
              <el-select
                placeholder="Select filter"
                clearable
                v-model="chartSelectedFilter"
                class="mb-1 !w-full"
              >
                <el-option
                  v-for="fl in chartFilters.filter((e) => !e.parent_filter_id)"
                  :key="fl._id"
                  :value="fl._id"
                  :label="fl.filter_name"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div v-if="chartType == 'BAR' && pieChartField">
                <el-collapse>
                  <el-collapse-item>
                    <template slot="title">Selected Options Color Coding</template>
                    <div class="overflow-x-auto">
                      <table
                        class="table table-striped"
                        style="z-index: 1000; border: 10px; margin: 2px 0px"
                      >
                        <tr>
                          <td v-for="(op, i) in pieChartFieldOptions" :key="op">
                            <el-color-picker
                              class="!border-none"
                              size="mini"
                              v-model="pieChartFieldOptionsColors[i]"
                            ></el-color-picker>
                            <p style="font-size: 12px" class="!border-none">
                              {{
                                checkFieldType(pieChartField, 'ENTITY') ? getOptionLabel(op) : op
                              }}
                            </p>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-col>
          </el-row>

          <template v-if="chartType == 'COMBINATION'">
            <el-row :gutter="20">
              <el-col :span="12">
                <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Show total</h4>
              </el-col>
              <el-col :span="8">
                <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">
                  Select Type
                </h4>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-for="(row, index) in rows" :key="index">
              <el-col :span="12">
                <el-select
                  v-model="row.sum_field"
                  placeholder="Total field"
                  class="mb-1 !w-full"
                  clearable
                >
                  <el-option
                    v-for="(field, fieldIndex) in getTotalFields"
                    :value="field.key"
                    :key="field.key + fieldIndex"
                    :label="`${field.template_name} - ${field.label} `"
                    :disabled="isOptionDisabled(row.sum_field, field.key, index)"
                  >
                    <span>{{ field.template_name }} - {{ field.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="row.chart_type"
                  filterable
                  default-first-option
                  class="mb-1 !w-full"
                >
                  <el-option
                    v-for="(field, fieldIndex) in subChartTypes"
                    :value="field.value"
                    :key="field.value + fieldIndex"
                    :label="field.label"
                  >
                    <span>{{ field.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="1">
                <el-link :underline="false" type="primary" style="margin-left: 3px" @click="addRow">
                  <i class="el-icon-circle-plus !text-brand-500"></i>
                </el-link>
              </el-col>
              <el-col :span="1">
                <el-link
                  :underline="false"
                  type="primary"
                  style="margin-left: 3px"
                  @click="removeRow(index)"
                >
                  <i class="el-icon-remove !text-brand-500"></i>
                </el-link>
              </el-col>
            </el-row>
          </template>

          <template v-else>
            <el-row>
              <el-col>
                <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Show total</h4>
                <div class="flex-container mb-1">
                  <el-select
                    v-model="sum_fields"
                    placeholder="Total field"
                    class="flex-item"
                    clearable
                    multiple
                    :multiple-limit="pieChartFieldGroupBy ? 1 : null"
                    collapse-tags
                    @change="sum_fields && sum_fields.length > 1 ? (pieChartFieldGroupBy = '') : ''"
                  >
                    <el-option
                      v-for="(field, index) of getTotalFields"
                      :value="field.key"
                      :key="field.key + index"
                      :label="`${field.template_name} - ${field.label} `"
                    >
                      <span>{{ field.template_name }} - {{ field.label }}</span>
                    </el-option>
                  </el-select>
                  <el-color-picker
                    v-if="chartType == 'BAR' && sum_fields.length <= 1"
                    v-model="BarColor"
                    class="flex-item"
                    size="mini"
                  ></el-color-picker>
                </div>
              </el-col>
              <el-col>
                <el-checkbox
                  v-model="isStacked"
                  v-if="chartType == 'BAR' && sum_fields.length > 1"
                  class="mt-1 mr-1"
                >
                  Stacked
                </el-checkbox>
                <el-switch
                  size="mini"
                  v-if="isStacked"
                  v-model="startFrom"
                  :active-value="true"
                  :inactive-value="false"
                  active-color="var(--brand-500)"
                  inactive-color="var(--black-200)"
                ></el-switch>
                <span v-if="isStacked">Start From 0</span>
              </el-col>
            </el-row>
          </template>

          <el-select
            placeholder="Group by"
            v-model="pieChartFieldGroupBy"
            v-if="
              pieChartField &&
              (!sum_fields || !sum_fields.length || sum_fields.length == 1) &&
              chartType != 'COMBINATION'
            "
            :clearable="true"
            @change="getSelectedFieldOptions"
          >
            <el-option
              v-for="(field, index) of getTemplateFields.filter(
                (e) => e.key != pieChartField && e.input_type != 'DATE'
              )"
              :value="field.key"
              :key="field.key + index"
              :label="`${field.template_name} - ${field.label} `"
            >
              <span>{{ field.template_name }} - {{ field.label }}</span>
            </el-option>
          </el-select>
          <el-checkbox class="!mx-4" v-model="includeChartTotal" v-if="pieChartFieldGroupBy">
            Include total
          </el-checkbox>
          <el-select
            placeholder="Select options to group"
            multiple
            v-model="pieChartFieldGroupBySelectedOptions"
            v-if="pieChartFieldGroupBy"
            :clearable="true"
            class="mt-1"
            collapse-tags
          >
            <template v-if="checkFieldType(pieChartFieldGroupBy, 'ENTITY')">
              <el-option
                v-for="(data, index) of groupByFieldEntityValues"
                :key="index + 'entity' + data._id"
                :value="data._id"
                :label="getLabel(data, index, groupByFieldEntity)"
              >
                <span>{{ getLabel(data, index, groupByFieldEntity) }}</span>
              </el-option>
            </template>
            <template v-else>
              <el-option
                v-for="(option, index) of pieChartFieldGroupByOptions"
                :value="option"
                :key="index"
                :label="option"
              >
                <span>{{ option }}</span>
              </el-option>
            </template>
          </el-select>

          <h4 class="!font-normal !text-black-950 !mb-1 !mt-3 !text-xs 2xl:!text-sm">
            Apply date filter on this field:
          </h4>

          <el-select
            placeholder="Select date field"
            v-model="date_filter_field"
            default-first-option
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="(field, index) of getAllDateFields"
              :value="field.key"
              :key="field.key + '_stat_' + index"
              :label="`${field.template_name} - ${field.label} `"
            >
              <span>{{ field.template_name }} - {{ field.label }}</span>
            </el-option>
            <el-option value="created_at" label="Created Date">Created Date</el-option>
            <el-option value="updated_at" label="Updated Date">Updated Date</el-option>
          </el-select>
          <span
            class="yale-blue mb-1 mt-1"
            style="font-size: 12px"
            v-if="selectedComponentType == 'CHART'"
          >
            NOTE: 'SELECT', 'YES OR NO', 'MULTI SELECT', 'ENTITY' fields can be used for chart
            representation
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="chartsPopUpClose"
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800 !mr-1"
        >
          Cancel
        </el-button>
        <el-button type="primary" :disabled="isSaveButtonDisabled" @click="saveChartData">
          Save
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :title="'Charts Component'"
      :visible="thirdPartyChartsDialogVisible"
      @before-close="closeIntgerationsPopup"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :containerWidth="'50%'"
      class="chart-component-sty"
    >
      <div v-loading="loading" element-loading-text="Please wait, Generating chart...">
        <div>
          <div>
            <div>
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Stat Icon</h4>
              <el-button
                type="text"
                class="text-center ml-1"
                @click="iconPickerdialogVisible = true"
              >
                <div class="menu-icon">
                  <icons
                    style="color: var(--brand-500)"
                    :iconName="
                      integrationComponent.chartIcon ? integrationComponent.chartIcon : 'dashboard'
                    "
                  ></icons>
                </div>
              </el-button>
            </div>
            <div class="mt-1 mr-1 mb-1">
              <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">
                Enter Component Name:
              </h4>
              <el-input v-model="integrationComponent.component_name"></el-input>
            </div>
            <el-row>
              <el-col :span="12">
                <h4 class="!font-normal !text-black-950 !mb-1 !text-xs 2xl:!text-sm">Chart type</h4>
                <el-select
                  v-model="integrationComponent.chart_type"
                  filterable
                  default-first-option
                  class="mb-1"
                >
                  <el-option
                    v-for="(field, index) of chartTypes"
                    :value="field.value"
                    :key="field.value + index"
                    :label="field.label"
                  >
                    <span>{{ field.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <IntegrationConfiguration
              :addStatsData="integrationComponent"
              :integrations="integrations"
              :customDashboardData="customDashboardData"
            ></IntegrationConfiguration>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="closeIntgerationsPopup"
          class="!border-none !bg-transparent !text-black-800 hover:!bg-transparent hover:!text-black-800 !mr-1"
        >
          Cancel
        </el-button>
        <el-button
          type="primary"
          :disabled="isIntegrationsSaveButtonDisabled"
          @click="saveChartData"
        >
          Save
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :visible="configModal"
      :title="
        selectedComponentType == 'GAUGE_CHART' ? 'Configure Gauge Chart' : 'Configure Notifications'
      "
      :containerWidth="selectedComponentType == 'GAUGE_CHART' ? '55%' : '90%'"
      :containerMaxHeight="'90%'"
      @before-close="resetConfig"
    >
      <div class="mt-1 ml-1 mr-1">
        <label>Enter Component Name</label>
        <span class="text-red-500">*</span>
        <br />
        <el-input v-model="componentName"></el-input>
      </div>
      <div v-if="selectedComponentType != 'GAUGE_CHART'">
        <label>Show data based on :</label>
        <el-select
          :style="'width : 100%'"
          v-model="selectedRelationalFilter"
          placeholder="Self related Filter"
        >
          <el-option value="login_user" label="Login User"></el-option>
          <el-option
            v-for="item in getEntityFieldsCurrentEntity"
            :key="item.entity_id"
            :label="item.label"
            :value="item.entity_id + '#' + item.template_key"
          ></el-option>
        </el-select>
      </div>

      <div v-if="selectedComponentType == 'GAUGE_CHART'">
        <div
          class="d-flex mt-1"
          style="justify-content: space-between; padding: 0px 20px; gap: 20px"
        >
          <div>
            <span><b>Numerator</b></span>
            <div class="mt-1">
              <label>Entity</label>
              <br />
              <el-select
                v-if="isEntityDashboard"
                v-model="gaugeChartNumerator.relationship_id"
                @change="isRelationshipChanged('NUMERATOR')"
              >
                <el-option-group label="Relationships">
                  <el-option
                    v-for="(entity, index) of getRelationshipEntities"
                    :value="entity._id"
                    :key="index"
                    :label="'My ' + entity.name"
                  ></el-option>
                </el-option-group>
                <el-option-group label="Nested Relationships">
                  <el-option
                    v-for="(op, i) in getNestedRelationshipEntities"
                    :key="op.key + i"
                    :value="op.key"
                    :label="'My ' + op.name"
                  ></el-option>
                </el-option-group>
              </el-select>
              <el-select
                v-else
                v-model="gaugeChartNumerator.entity_id"
                filterable
                clearable
                @change="fetchGaugeChartDetails('NUMERATOR')"
              >
                <el-option
                  v-for="(entity, index) of getAllEntitiesData"
                  :value="entity._id"
                  :key="index"
                  :label="entity.name"
                >
                  <span style="float: left">{{ entity.name }}</span>
                </el-option>
              </el-select>
              <br />
              <br />
              <label>Filter</label>
              <br />
              <el-select
                v-model="gaugeChartNumerator.filter_id"
                filterable
                clearable
                :loading="numeratorFiltersLoading"
                loading-text="Loading..."
              >
                <el-option
                  v-for="(filter, index) in numeratorFiters.filter((e) => !e.parent_filter_id)"
                  :key="index"
                  :value="filter._id"
                  :label="filter.filter_name"
                ></el-option>
              </el-select>
              <br />
              <br />
              <el-radio-group v-model="gaugeChartNumerator.display_type">
                <el-radio label="count">Count</el-radio>
                <el-radio label="sum">Sum</el-radio>
                <el-radio label="avg">Average</el-radio>
              </el-radio-group>
              <br />
              <br />
              <div v-if="gaugeChartNumerator.display_type == 'count'">
                <el-checkbox v-model="gaugeChartNumerator.showCount">Show Filter Count</el-checkbox>
              </div>
              <div v-if="gaugeChartNumerator.display_type != 'count'">
                <label>Field</label>
                <br />
                <el-select
                  :loading="numeratorFieldsLoading"
                  loading-text="Loading..."
                  v-model="gaugeChartNumerator.sum_field"
                >
                  <el-option
                    v-for="(field, index) in numeratorEntityFields"
                    :key="index"
                    :value="field.template_key"
                    :label="field.label"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div>
            <span><b>Denominator</b></span>
            <div class="mt-1">
              <label>Entity</label>
              <br />
              <el-select
                v-if="isEntityDashboard"
                v-model="gaugeChartDenominator.relationship_id"
                @change="isRelationshipChanged('DENOMINATOR')"
              >
                <el-option-group label="Relationships">
                  <el-option
                    v-for="(entity, index) of getRelationshipEntities"
                    :value="entity._id"
                    :key="index"
                    :label="'My ' + entity.name"
                  ></el-option>
                </el-option-group>
                <el-option-group label="Nested Relationships">
                  <el-option
                    v-for="(op, i) in getNestedRelationshipEntities"
                    :key="op.key + i"
                    :value="op.key"
                    :label="'My ' + op.name"
                  ></el-option>
                </el-option-group>
              </el-select>
              <el-select
                v-else
                v-model="gaugeChartDenominator.entity_id"
                filterable
                clearable
                @change="fetchGaugeChartDetails('DENOMINATOR')"
              >
                <el-option
                  v-for="(entity, index) of getAllEntitiesData"
                  :value="entity._id"
                  :key="index"
                  :label="entity.name"
                >
                  <span style="float: left">{{ entity.name }}</span>
                </el-option>
              </el-select>
              <br />
              <br />
              <label>Filter</label>
              <br />
              <el-select
                v-model="gaugeChartDenominator.filter_id"
                filterable
                clearable
                :loading="denominatorFiltersLoading"
                loading-text="Loading..."
              >
                <el-option
                  v-for="(filter, index) in denominatorFilters.filter((e) => !e.parent_filter_id)"
                  :key="index"
                  :value="filter._id"
                  :label="filter.filter_name"
                ></el-option>
              </el-select>
              <br />
              <br />
              <el-radio-group v-model="gaugeChartDenominator.display_type">
                <el-radio label="count">Count</el-radio>
                <el-radio label="sum">Sum</el-radio>
                <el-radio label="avg">Average</el-radio>
              </el-radio-group>
              <br />
              <br />
              <div v-if="gaugeChartDenominator.display_type == 'count'">
                <el-checkbox v-model="gaugeChartDenominator.showCount">
                  Show Filter Count
                </el-checkbox>
              </div>
              <div v-if="gaugeChartDenominator.display_type != 'count'">
                <label>Field</label>
                <br />
                <el-select
                  :loading="denominatorFieldsLoading"
                  loading-text="Loading..."
                  v-model="gaugeChartDenominator.sum_field"
                >
                  <el-option
                    v-for="(field, index) in denominatorEntityFields"
                    :key="index"
                    :value="field.template_key"
                    :label="field.label"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div>
            <span>
              <b>Customization</b>
              <br />
              <div class="mt-1">
                <label>Delimeters</label>
                <br />
                <el-input
                  placeholder="Ex : 25, 50, 75"
                  v-model="gaugeChartCustomization.delemeters"
                  @input="customizationChanged"
                  style="width: 250px"
                ></el-input>
                <br />
                <span>Note : Enter delimeters seperated by ","</span>
              </div>
              <br />
              <label>Delimeter Colors</label>
              <br />
              <div class="mt-1 d-flex">
                <div
                  v-for="(del, index) in gaugeChartCustomization.delemeterColors"
                  :key="del + '_' + index"
                  class="mr-1"
                >
                  <el-color-picker
                    v-model="gaugeChartCustomization.delemeterColors[index]"
                    size="mini"
                  ></el-color-picker>
                  <p style="font-size: 10px">
                    {{ getDelemeterRangeLabel(index) }}
                  </p>
                </div>
              </div>
            </span>
          </div>
        </div>
        <div class="mb-1 mt-1">
          <el-checkbox v-model="gaugeChartCustomization.showLegend">Show legends</el-checkbox>
        </div>
        <div class="mb-1 mt-1">
          <el-checkbox v-model="gaugeChartCustomization.showExpand">Show Expand</el-checkbox>
        </div>
        <div class="mb-1">
          <el-link :underline="false" style="color: #409eff" @click="addGaugeFilter">
            Add Quick Filters+
          </el-link>
          <el-row v-for="(filter, index) in gaugeFilters" :key="index" class="mt-1">
            <el-tooltip content="Select Entity">
              <el-select
                size="mini"
                v-model="filter.entity_id"
                filterable
                clearable
                style="width: 150px"
              >
                <el-option
                  v-for="(entity, index) in getAllEntitiesData"
                  :key="index"
                  :value="entity._id"
                  :label="entity.name"
                ></el-option>
              </el-select>
            </el-tooltip>
            <el-select size="mini" v-model="filter.as" class="ml-1" style="width: 150px">
              <el-option label="As Relationship" value="RELATIONSHIP"></el-option>
              <el-option label="As Field" value="FIELD" :disabled="true"></el-option>
            </el-select>
            <span class="ml-1 mr-1">Apply on</span>
            <el-checkbox v-model="filter.numerator">Numerator</el-checkbox>
            <el-checkbox v-model="filter.denominator">Denominator</el-checkbox>
            <el-link
              :underline="false"
              style="color: #409eff"
              @click="removeGaugeFilter(index)"
              class="ml-1"
            >
              Remove
            </el-link>
          </el-row>
        </div>
      </div>
      <div v-else class="ml-1 mt-1">
        <el-button type="success" @click="addNewNotification" style="margin: 10px">
          Add New +
        </el-button>
        <el-scrollbar
          wrap-style="max-height: 300px; overflow-x: auto; overflow-y: auto; scrollbar-width:thin;"
        >
          <div>
            <el-table :data="notifications" size="mini" border>
              <el-table-column label="Type">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.type" size="mini">
                    <el-option value="IN_APP_NOTIFICATIONS" label="App Notifications"></el-option>
                    <el-option value="EVENT_NOTIFICATIONS" label="Event Notifications"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="Entity *">
                <template slot-scope="scope">
                  <el-select
                    v-if="isEntityDashboard"
                    v-model="scope.row.relationship_id"
                    size="mini"
                    filterable
                    clearable
                    @change="isRelationshipEntityChanged(scope.row.relationship_id, scope.$index)"
                  >
                    <el-option-group label="Relationships">
                      <el-option
                        v-for="(entity, index) in getRelationshipEntities"
                        :key="index"
                        :value="entity._id"
                        :label="'My ' + entity.name"
                      ></el-option>
                    </el-option-group>
                    <el-option-group label="Nested Relationships">
                      <el-option
                        v-for="(op, i) in getNestedRelationshipEntities"
                        :key="op.key + i"
                        :value="op.key"
                        :label="'My ' + op.name"
                      ></el-option>
                    </el-option-group>
                    <el-option-group label="Other Entities">
                      <el-option
                        v-for="(entity, index) in getAllEntitiesData"
                        :key="index"
                        :value="entity._id + '@OTHER_ENTITY'"
                        :label="entity.name"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                    v-else-if="!scope.row.formbuilder_id"
                    v-model="scope.row.entity_id"
                    size="mini"
                    filterable
                    clearable
                    @change="notificationEntityChanged(scope.row.entity_id, scope.$index)"
                  >
                    <el-option
                      v-for="(entity, index) in getAllEntitiesData"
                      :key="index"
                      :value="entity._id"
                      :label="entity.name"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="Form builder *">
                <template slot-scope="scope">
                  <el-select
                    v-if="!scope.row.entity_id && scope.row.type == 'IN_APP_NOTIFICATIONS'"
                    v-model="scope.row.formbuilder_id"
                    size="mini"
                    filterable
                    clearable
                    @change="updateFormbuilderData(scope.row.formbuilder_id, scope.$index)"
                  >
                    <el-option
                      v-for="(formbuilder, i) in allFormbuilders"
                      :key="formbuilder._id + '_' + i"
                      :label="formbuilder.name"
                      :value="formbuilder._id + '#' + formbuilder.name + '#' + formbuilder.code"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="Filter">
                <template slot-scope="scope">
                  <el-select
                    v-if="!scope.row.formbuilder_id"
                    v-model="scope.row.filter"
                    size="mini"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="(filter, index) in (
                        entityFiltersMapping[scope.row.entity_id] || []
                      ).filter((e) => !e.parent_filter_id)"
                      :key="index"
                      :value="filter._id"
                      :label="filter.filter_name"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="Heading *">
                <template slot-scope="scope">
                  <div style="border: 0.5px solid grey" v-if="scope.row.entity_id">
                    <CustomEntityMention
                      :entity_id="scope.row.entity_id"
                      :data="scope.row"
                      :fromHeading="true"
                      :fromNotifications="true"
                    ></CustomEntityMention>
                  </div>
                  <div style="border: 0.5px solid grey" v-if="scope.row.formbuilder_id">
                    <CustomFormbuilderMention
                      :formbuilder_id="scope.row.formbuilder_id"
                      :data="scope.row"
                      :fromNotifications="true"
                    ></CustomFormbuilderMention>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Events">
                <template slot-scope="scope">
                  <el-select
                    v-if="scope.row.type == 'IN_APP_NOTIFICATIONS' && scope.row.entity_id"
                    v-model="scope.row.events"
                    multiple
                    size="mini"
                  >
                    <el-option label="Added" value="ADDED"></el-option>
                    <el-option label="Updated" value="UPDATED"></el-option>
                    <el-option label="Deleted" value="DELETED"></el-option>
                  </el-select>
                  <el-select
                    v-if="scope.row.type == 'IN_APP_NOTIFICATIONS' && scope.row.formbuilder_id"
                    v-model="scope.row.formBuilderEvents"
                    multiple
                    size="mini"
                  >
                    <el-option
                      v-for="event in allFormbuilderEvents"
                      :key="event.value"
                      :label="event.label"
                      :value="event.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="Appearence">
                <template slot-scope="scope">
                  <div class="d-flex">
                    <el-color-picker
                      size="mini"
                      v-model="scope.row.background_color"
                      class="mr-2"
                    ></el-color-picker>
                    <div @click="changeIcon(scope.$index)" class="card-icon">
                      <icons :iconName="scope.row.icon"></icons>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Custom message *" width="350">
                <template slot-scope="scope">
                  <div
                    style="border: 0.5px solid grey"
                    v-if="scope.row.entity_id && !scope.row.refresh"
                  >
                    <CustomEntityMention
                      :entity_id="scope.row.entity_id"
                      :data="scope.row"
                      :fromNotifications="true"
                    ></CustomEntityMention>
                  </div>
                  <div style="border: 0.5px solid grey" v-if="scope.row.formbuilder_id">
                    <CustomFormbuilderMention
                      :formbuilder_id="scope.row.formbuilder_id"
                      :data="scope.row"
                      :fromNotifications="true"
                    ></CustomFormbuilderMention>
                  </div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    circle
                    plain
                    type="danger"
                    @click="deleteNotification(scope.$index)"
                  >
                    <i class="el-icon-delete" />
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="Customization" width="120" align="center">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.customization"
                    placeholder="Select Customization"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in customizationOptions || []"
                      :key="item._id"
                      :label="item.label"
                      :value="item._id"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="Redirect" width="100" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.redirect">Allow</el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-scrollbar>
        <span>
          <b>Hint:</b>
          Type @ to mention the fields in the custom message
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <div>
          <el-button size="mini" @click="resetConfig" class="mr-1">Cancel</el-button>
          <el-button
            v-if="selectedComponentType == 'GAUGE_CHART'"
            type="primary"
            :disabled="disableGaugeSave()"
            @click="saveGaugeChart"
          >
            Save
          </el-button>
          <el-button
            v-else
            type="success"
            @click="saveNotifications"
            :disabled="disableNotificationSave()"
          >
            Save
          </el-button>
        </div>
      </span>
    </dialog-component>
    <dialog-component
      :title="'Select Menu Icon'"
      :visible="iconPickerdialogVisible"
      @before-close="iconPickerdialogVisible = false"
      :containerWidth="'1000px'"
    >
      <icons-list @icon-data="setIconData"></icons-list>
    </dialog-component>
    <dialog-component
      :title="'Color Rules'"
      :visible="colorRulesDialogVisible"
      @before-close="colorRulesDialogVisible = false"
      :containerWidth="'800px'"
    >
      <template-form-rules-widget
        :allFields="colorRulesFields"
        :templateRules="colorRules"
        :fromScheduling="true"
        @form-rule-added="updateFormRules"
        @form-rule-delete="deleteFormRules"
        class="popUp-content"
      ></template-form-rules-widget>
    </dialog-component>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { bus } from '../../main';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import returnGlobalIntegrationFilters from '@/mixins/CustomDashboardHelper.js';
  //import EntitiesHelper from "@/mixins/EntitiesHelper";
  import NavigationHelper from '@/mixins/navigationHelper';
  import draggable from 'vuedraggable';
  import chroma from 'chroma-js';
  import TemplateBuilderHelper from '@/mixins/templateBuilderHelper';

  // import axios from "@/config/axios";

  import { fetchGlobalVariables } from '@/repo/globalVariables';
  import { fetchEntityViews } from '@/repo/entityViewsRepo';
  // import { fetchEntitiesByPagination } from "@/repo/entityRepo";
  // import { getAllCompanyTemplatesByPagination } from "@/repo/templatesRepo";
  import {
    updateCustomDashboardData,
    addSingleCustomDashboardToLocal,
  } from '@/repo/customDashboardRepo';
  import { fetchAllEntityFiltersByEntity } from '@/repo/filtersRepo';
  import { postAPICall } from '@/helpers/httpHelper';
  import axios from 'axios';
  import { fetchEntityRelationships } from '@/repo/entityRelationshipsRepo';
  // import { fetchEntityById } from "@/repo/entityRepo";
  import { createIcons, getIconKeysFromMasterIcons } from '@/repo/iconsRepo';
  import { fetchAllEntityCustomizationsByEntity } from '@/repo/entityCustomizationRepo';
  import EntitiesHelper from '../../mixins/EntitiesHelper';
  import appConfig from '@/config/app';
  export default {
    mixins: [
      MobileRelatedHelper,
      CustomDashboardConfig,
      NavigationHelper,
      TemplateBuilderHelper,
      returnGlobalIntegrationFilters,
      EntitiesHelper,
    ],
    components: {
      CustomDashboardTable: () => import('./customDashboardTable.vue'),
      CustomDashboardStats: () => import('./customDashboardStats.vue'),
      CustomDashboardPieChart: () => import('./customDashboardPieChart.vue'),
      CustomDashboardFilters: () => import('./customDashboardFilters.vue'),
      CustomDashboardCalendar: () => import('./customDashboardCalendar.vue'),
      draggable,
      CustomDashboardCard: () => import('./customDashboardCard.vue'),
      CustomEntityMention: () => import('@/components/widgets/entityMention/index.vue'),
      CustomFormbuilderMention: () =>
        import('@/components/widgets/entityMention/formbuilderfieldsMention.vue'),
      CustomDashboardLogins: () => import('./customDashboardLogins.vue'),
      EntityViews: () => import('@/components/entity/EntityViews.vue'),
      SchedulingEntity: () => import('./schedulerComponent.vue'),
      CustomDashboardGauge: () => import('./customDashboardGaugeChart.vue'),
      CustomDashboardNotifications: () => import('./customDashboardNotifications.vue'),
      // CustomDashboardGanttChart :()=> import("./customDashboardGanttChart.vue"),
      IntegrationConfiguration: () => import('./integrationConfiguration.vue'),
      TemplateFormRulesWidget: () => import('@/components/widgets/TemplateFormRulesWidget.vue'),
    },
    data() {
      return {
        schedulerEntityFilters: [],
        selectedSchedulerFilter: '',
        currentEntity: null,
        currentEntityFields: [],
        allowMultipleSlots: false,
        integration_filters: {},
        goBackToCustom: false,
        componentDataFetched: false,
        userPrompt: '',
        chartIcon: '',
        showAiInput: false,
        apiResponse: null,
        customDashboardData: {
          allTableComponents: [],
          allStatComponents: [],
          allCustomFilters: [],
          name: '',
          includeGlobalDateFilter: false,
          allowUserChangeOrder: true,
          allMulCustomFilters: [],
          globalFilters: [],
          date_value: '',
          Custom_date_value: [],
          isFromIntegrations: false,
          selectedRelationalFilter: 'login_user',
        },
        integrationComponent: {
          component_name: '',
          type: 'CHART',
          chart_type: '',
          feature: 'ENTITY',
          isNew: true,
          date_filter_field: '',
          ignore_year: false,
          selected_fields: [],
          send_notification: false,
          compare: false,
          sort_by: '',
          sort_order: 'asc',
          compare_with: 'one',
          data_source: 'INTEGRATIONS',
          integrationsSettings: {
            integration_id: '',
            event: null,
            event_id: '',
            dependencies: {},
            selectedFields: [],
            globalFilters: [],
            exisitingFilterComponent: '',
            radioFilter: '1',
          },
          BarColor: this.BarColor,
        },
        dateFilter: false,
        ShowExport: false,
        selectedCalendarNestedRelationEntities: [],
        calendarName: '',
        rawData: null,
        centerDialogVisible: false,
        filters: [],
        selectedFilter: [],
        selectedEntityData: '',
        selectedCalendarEntities: [],
        selectedCalendarRelationEntities: [],
        selectedEntityRelationalData: '',
        filterSearchString: '',
        loading: false,
        layout: 'div',
        offCanvas: true,
        windowWidth: 1500,
        refresh: false,
        expendedIndexs: [],
        loadingText: 'Loading...',
        selectedComponentType: 'TABLE',
        pieChartField: '',
        pieChartFieldGroupBy: '',
        sum_fields: [],
        pieChartFieldGroupByOptions: [],
        includeChartTotal: false,
        calenderDateField: [],
        chartType: '',
        pieChartFieldOptions: [],
        pieChartFieldOptionsColors: [],
        pieChartFieldSelectOptions: [],
        pieChartFieldEntityValues: [],
        pieChartFieldEntity: null,
        getFieldOptions: [],
        customFilterField: [],
        componentTypes: [
          {
            label: 'Table',
            value: 'TABLE',
          },
          {
            label: 'Chart',
            value: 'CHART',
          },
          // {
          //   label: "Card",
          //   value: "CARD"
          // },
          {
            label: 'Custom filters',
            value: 'CUSTOM_FILTER',
          },
          {
            label: 'Calendar',
            value: 'CALENDAR',
          },
          {
            label: 'Logins',
            value: 'LOGINS',
          },
          {
            label: 'Attendance',
            value: 'ATTENDANCE',
          },
          {
            label: 'Entity Views',
            value: 'ENTITY_VIEW',
          },
          {
            label: 'Scheduling',
            value: 'SCHEDULING',
          },
          {
            label: 'Gauge Chart',
            value: 'GAUGE_CHART',
          },
          {
            label: 'Notifications',
            value: 'NOTIFICATIONS',
          },
          {
            label: 'Multiple Custom filters',
            value: 'MULTIPLE_CUSTOM_FILTER',
          },
        ],
        chartTypes: [
          {
            label: 'Pie',
            value: 'PIE',
          },
          {
            label: 'Bar',
            value: 'BAR',
          },
          {
            label: 'Doughnut',
            value: 'DOUGHNUT',
          },
          {
            label: 'Line',
            value: 'LINE',
          },
          {
            label: 'Combination',
            value: 'COMBINATION',
          },
        ],
        getTemplateFields: [],
        getTemplateDateFields: [],
        globalVariablesData: [],
        tableData: [],
        isEntityDashboard: false,
        permittedEntities: [],
        permittedRelatedEntities: [],
        permittedNestedRelatedEntities: [],
        relationshipEntities: [],
        allEntityFilters: [],
        getTotalFields: [],
        allFormbuilderEvents: [
          {
            value: 'FILLED',
            label: 'Filled',
          },
          {
            value: 'APPROVED',
            label: 'Approved',
          },
          {
            value: 'REJECTED',
            label: 'Rejected',
          },
        ],
        pieChartFieldGroupBySelectedOptions: [],
        selectedValues: [],
        groupByFieldEntityValues: [],
        groupByFieldEntity: null,
        chartFilters: [],
        chartSelectedFilter: '',
        tableFieldGroupBy: '',
        tableFieldSubGroupBy: '',
        tableFieldGroupByFields: [
          {
            key: 'count',
            name: 'Count',
            type: 'count',
            sub_group: false,
          },
        ],
        tableFieldGroupByFieldsModal: [],
        openTableColumsModal: false,
        tableFieldGroupBySelectedOptions: [],
        allTemplates: [],
        allowOtherShowData: false,
        // getAllCompanyTemplatesData: null,
        centerLoginsDialogVisible: false,
        loginsDialogVisible: false,
        actionOptions: [
          { label: 'Login', value: 'login' },
          { label: 'Logout', value: 'logout' },
          { label: 'Duration', value: 'duration' },
          // Add more options as needed
        ],
        info: [
          { component: 'Date', field: '' },
          { component: 'Login', field: '' },
          { component: 'Logout', field: '' },
          { component: 'Duration', field: '' },
          // { component: "Login Location", field: "" },
          // { component: "Logout Location", field: "" },
        ],
        loginLogoutDropdownData: [
          { component: 'Login Dropdown', fields: [] },
          { component: 'Logout Dropdown', fields: [] },
          { component: 'After Logout', fields: [] },
        ],
        attendance: {
          loginFilter: '',
          start_button: '',
          end_button: '',
          isGeoFenceRequired: false,
          selectedLoginLocation: '',
          selectedLogoutLocation: '',
          geoFenceRadius: null,
          geoFenceCoordinates: [],
          user_field: '',
          companyuser_field: '',
          Days: '',
          new_attendance: [
            { component: 'Swipe', key: 'swipe', type: 'DATE', field: '' },
            {
              component: 'Login Type',
              key: 'login_type',
              type: 'SELECT',
              field: '',
            },
            { component: 'Device Id', key: 'deviceId', type: 'TEXT', field: '' },
            {
              component: 'IP Address',
              key: 'ip_address',
              type: 'TEXT',
              field: '',
            },
            {
              component: 'Location (GEO)',
              key: 'geo_location',
              type: 'TEXT',
              field: '',
            },
            { component: 'Auth Type', key: 'auth_type', type: 'TEXT', field: '' },
            {
              component: 'Biometric Id',
              key: 'bio_id',
              type: 'Number',
              field: '',
            },
          ],
        },

        allEntityFields: [],
        allDateTimeFields: [],
        selectedLoginEntity: '',
        selectedLoginEntityRelationalData: '',
        selectedEntityView: '',
        isRelationalData: false,
        loginsDataDetails: [],
        getTemplateTimeFields: [],
        start_button: '',
        end_button: '',
        loginFilter: '',
        loginEntityFilters: [],
        isloginIndex: [],
        Days: '',
        shouldDisplayInput: false,
        displayAutoLogout: false,
        user_field: '',
        entityField: [],
        auto_logout: '',
        selectedFieldType: '',
        dateTimeFieldObject: null,
        fieldSelected: false,
        selectedFirstField: null,
        refreshComponents: false,
        textField: [],
        companyuser_field: '',
        getAllEntities: null,
        getAllEntityViews: null,
        //scheduler variables
        resourceEntity: '',
        jobEntity: '',
        schedulerEntity: '',
        applyRelationship: false,
        schedulerEntityDateField: '',
        schedulerEntityResourceLabelField: [],
        schedulerEntityJobLabelDateField: [],
        jobEntityTimeField: '',
        resourceEntityTimeField: '',
        schedulerEntitySubGroups: [],
        entityFilterObject: {},
        schedulerComponentName: '',
        rows: [{ sum_field: null, chart_type: null }],
        combinedData: [],
        subChartTypes: [
          {
            label: 'Line',
            value: 'line',
          },
          {
            label: 'Bar',
            value: 'bar',
          },
        ],
        centerChartsDialogVisible: false,
        thirdPartyChartsDialogVisible: false,
        componentName: '',
        selectedRelationalFilter: 'login_user',
        gaugeChartNumerator: {
          display_type: 'count',
          showCount: false,
        },
        gaugeChartDenominator: {
          display_type: 'count',
          showCount: false,
        },
        numeratorFiters: [],
        denominatorFilters: [],
        numeratorEntityFields: [],
        denominatorEntityFields: [],
        numeratorFiltersLoading: false,
        denominatorFiltersLoading: false,
        configModal: false,
        numeratorFieldsLoading: false,
        denominatorFieldsLoading: false,
        editIndex: -1,
        gaugeFilters: [],
        notifications: [],
        entityFiltersMapping: {},
        iconPickerdialogVisible: false,
        iconEditIndex: -1,
        gaugeChartCustomization: {
          delemeters: '',
          delemeterColors: [],
          showLegend: true,
          showExpand: true,
        },
        chartComponentName: '',
        chartDescription: '',
        BarColor: '',
        schedulingEntityFields: [],
        jobEntityFields: [],
        resourceEntityFields: [],
        integrations: [],
        isStacked: false,
        multipleCustomFilterField: '',
        selectedMulCustomFilterEntity: [],
        entityOptions: [],
        matchingFieldKeys: [],
        orderedMatchingFieldKeys: [],
        multipleFilterDependencies: [],
        multipleFilterDependency: '',
        schedulerEntitySubGroupsFilters: [],
        schedulerEntitySubGroupsData: [],
        getAllDateFields: [],
        date_filter_field: '',
        allFormbuilders: [],
        barOrientation: 'vertical',
        colorRulesDialogVisible: false,
        colorRules: [],
        colorRulesFields: [],
        isDropdownVisible: false,
        isGeoFenceRequired: false,
        selectedLoginLocation: null,
        selectedLogoutLocation: null,
        allLocationFields: [],
        geoFenceCoordinates: [],
        geoFenceRadius: null,
        allDropdownfields: [],
        timeDuration: false,
        swipeConfig: {
          show: true,
          label: 'View Swipes',
        },
        isCustomization: false,
        customizationOptions: [],
        selectedCustomization: '',
        role_id: null,
      };
    },
    computed: {
      ...mapGetters('entities', [
        // "getAllEntities",
        'getEntityDataByEntityId',
        'geCustomDashboardPieStats',
        'getEntityRecordsForTable',
        'getChildEntityDataById',
      ]),
      ...mapGetters('filters', [
        'getAllEntityFilters',
        'getCreateNewFilter',
        'getUpdateFilterStatus',
        'getDeleteFilterStatus',
      ]),
      ...mapGetters('customDashboard', [
        'getSingleDashboardData',
        'getUpdateDashboardStatus',
        'getUpdateDashboardData',
        'getUpdateDashboardError',
        'getCreateNewDashboard',
        'getCreateNewDashboardError',
      ]),
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getAuthenticationStatus',
        'getWorkspaceList',
        'getUserType',
        'getSwitchWorkspaceError',
        'getPermissionList',
        'getPermissions',
        'getGlobalFiltervalue',
        'getAuthenticationDetails',
        'getUserTypeList',
        'getUserTypeEmailsErrors',
        'getUserTypeEmails',
      ]),
      ...mapGetters('company', [
        'getCompanyDetails',
        'getUpdateCompany',
        'getCompanyLogo',
        'getSingleCompanyLogo',
        'getContactLoginSlug',
      ]),
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('companyTemplates', ['getAllCompanyTemplatesData']),
      // ...mapGetters("globalVariables", ["getAllGlobalVariables"]),
      ...mapGetters('applicationUsersPermission', [
        'getCreatePermissionStatus',
        'getEntityPermission',
        'getUpdatePermissionStatus',
        'getAllEntityPermissions',
      ]),
      ...mapGetters('entityRelationships', ['getEntityRelationships']),
      ...mapGetters('sso', ['getAuthenticatedSSOToken']),
      // ...mapGetters("entityViews", ["getAllEntityViews"]),
      getAllEntitiesData() {
        if (this.getAllEntities && this.getAllEntities?.data) {
          if (this.isEntityDashboard) {
            return (this.getAllEntities.data || []).filter(
              (e) => this.permittedEntities.indexOf(e._id) != -1
            );
          }
          return this.getAllEntities.data;
        }
        return [];
      },
      getEntityFieldsCurrentEntity() {
        console.log('this.currentEntityFields', this.currentEntityFields);
        if (!this.currentEntityFields?.length) return [];
        return (this.currentEntityFields || []).filter((e) => e.input_type == 'ENTITY') || [];
      },
      getNestedRelationshipEntities() {
        if (this.getAllEntities?.data) {
          if (
            this.getEntityPermission?._id &&
            this.permittedNestedRelatedEntities &&
            this.permittedNestedRelatedEntities.length
          ) {
            return this.permittedNestedRelatedEntities
              .map((rl) => {
                let [e1, e2] = rl.split('#');
                let entity1 = this.getAllEntities.data.find((e) => e._id == e1);
                let entity2 = this.getAllEntities.data.find((e) => e._id == e2);
                if (entity1?.name && entity2?.name) {
                  return {
                    name: entity1.name + ' / ' + entity2.name,
                    key: rl,
                  };
                }
              })
              .filter((rl) => ![undefined, null, ''].includes(rl));
          }
          return [];
        }
        return [];
      },
      getRelationshipEntities() {
        if (this.getAllEntities?.data) {
          if (this.getEntityPermission?._id) {
            return this.getAllEntities.data.filter(
              (e) => this.permittedRelatedEntities.indexOf(e._id) != -1
            );
          }
          if (this.relationshipEntities && this.relationshipEntities.length) {
            return this.getAllEntities.data.filter(
              (e) => this.relationshipEntities.indexOf(e._id) != -1
            );
          }
          return [];
        }
        return [];
      },
      getCurrentEntitiesData() {
        let currentEntities = [];
        if (this.customDashboardData) {
          if (
            this.customDashboardData.allTableComponents &&
            this.customDashboardData.allTableComponents.length
          ) {
            currentEntities = [
              ...currentEntities,
              ...this.customDashboardData.allTableComponents.flatMap((e) => e.entity_id),
            ];
          }
          if (
            this.customDashboardData.allStatComponents &&
            this.customDashboardData.allStatComponents.length
          ) {
            currentEntities = [
              ...currentEntities,
              ...this.customDashboardData.allStatComponents.flatMap((e) => e.entity_id),
            ];
          }
        }
        return this.getAllEntities && this.getAllEntities.data
          ? this.getAllEntities.data.filter((e) => currentEntities.indexOf(e._id) !== -1)
          : [];
      },
      getCurrentEntitiesFields() {
        let entities = this.getCurrentEntitiesData;
        const templateFields = [];

        entities.forEach((entityObject) => {
          const id = entityObject._id;
          let entity = this.getAllEntitiesData.find((e) => e._id === id);
          if (!entity) {
            entity = this.getRelationshipEntities.find((e) => e._id === id);
          }
          const templateIds = (entity.templates || [])
            .filter((e) => !e.is_repeatable)
            .map((e) => e.template_id);
          const entityTemplates = this.allTemplates.filter((e) => templateIds.includes(e._id));
          entityTemplates.forEach((e) => {
            const data = JSON.parse(JSON.stringify(e));
            const fieldTypes = ['ENTITY'];
            const fields = this.getTemplateFieldsByType(data, fieldTypes);

            templateFields.push(...fields);
          });
        });
        return templateFields;
      },
      checkIsDisabled() {
        if (this.selectedComponentType == 'GAUGE_CHART') {
          if (!this.gaugeChartNumerator.entity_id || !this.gaugeChartDenominator.entity_id) {
            return true;
          }
          return false;
        } else if (this.selectedComponentType == 'NOTIFICATIONS') {
          if (
            this.componentName == '' ||
            this.notifications.filter((n) => !n.entity_id && !n.formbuilder_id).length
          ) {
            return true;
          }
          return false;
        } else if (this.selectedComponentType == 'CHART') {
          if (!this.chartType) {
            return true;
          }
          return false;
        } else if (this.selectedComponentType == 'LOGINS') {
          return !this.loginsDataDetails.length;
        } else if (this.selectedComponentType == 'SCHEDULING') {
          return (
            !this.resourceEntity ||
            !this.jobEntity ||
            !this.schedulerEntity ||
            !this.schedulerComponentName ||
            !this.schedulerEntityDateField
          );
        } else if (this.selectedComponentType == 'ENTITY_VIEW') {
          return this.selectedEntityView == '';
        } else if (this.selectedComponentType == 'MULTIPLE_CUSTOM_FILTER') {
          return !this.multipleCustomFilterField || !this.selectedMulCustomFilterEntity;
        } else {
          if (this.selectedComponentType == 'CALENDAR') {
            return (
              !this.calenderDateField.length ||
              (!this.selectedCalendarEntities.length &&
                !this.selectedCalendarRelationEntities.length &&
                !this.selectedCalendarNestedRelationEntities.length)
            );
          }
          return (
            !this.selectedComponentType ||
            (!this.selectedEntityData &&
              !this.selectedEntityRelationalData &&
              (!this.selectedCalendarEntities || !this.selectedCalendarEntities.length)) ||
            // (this.selectedComponentType == "TABLE" &&
            // !this.selectedFilter.length &&
            // !this.selectedEntityRelationalData) ||
            (this.selectedComponentType == 'CALENDAR' && this.calenderDateField.length == 0)
          );
        }
      },
      disableSave() {
        if (this.tableData.length == 0) {
          return true;
        }
        let calendarname = this.calendarName;
        if (calendarname.length == 0) {
          return true;
        }
        let empty = this.tableData.find(
          (e) =>
            !e.field ||
            !e.custom_message ||
            (typeof e.custom_message == 'object' && Object.keys(e.custom_message).length == 0) ||
            !e?.custom_message?.content[0]?.content
        );
        if (empty) {
          return true;
        }
        return false;
      },
      disableloginSave() {
        if (this.info.length == 0) {
          return true;
        }
        // let empty = this.info.slice(0, 4).find((e) => !e.field);
        if (this.start_button == '' || this.end_button == '') {
          return true;
        }
        if (this.shouldDisplayInput == true) {
          if (this.Days == '') {
            return true;
          } else {
            return false;
          }
        }
        return false;
      },

      validateNewLogin() {
        if (this.attendance.new_attendance.length == 0) {
          return true;
        }
        let empty = this.attendance.new_attendance.slice(0, 4).find((e) => !e.field);
        if (empty || this.attendance.start_button == '' || this.attendance.end_button == '') {
          return true;
        }
        if (this.shouldDisplayInput == true) {
          if (this.attendance.Days == '') {
            return true;
          } else {
            return false;
          }
        }
        return false;
      },

      checkTableGroupByField() {
        if (this.tableFieldGroupByFieldsModal && this.tableFieldGroupByFieldsModal.length) {
          let empty = this.tableFieldGroupByFieldsModal.find((e) => !e || !e.name || !e.key);
          return empty ? true : false;
        }
        return !this.tableFieldGroupByFieldsModal || !this.tableFieldGroupByFieldsModal.length;
      },
      isEntitySelectDisabled() {
        if (this.selectedEntityRelationalData) {
          return true;
        } else {
          return false;
        }
      },
      isEntitySelectDisabledForLogin() {
        if (this.selectedLoginEntityRelationalData) {
          return true;
        } else {
          return false;
        }
      },
      isRelationalSelectDisabled() {
        if (this.selectedLoginEntity) {
          return true;
        } else {
          return false;
        }
      },
      isSaveButtonDisabled() {
        return !this.chartComponentName.trim() || !this.chartType || !this.pieChartField;
      },
      isIntegrationsSaveButtonDisabled() {
        return (
          !this.integrationComponent.component_name?.trim() ||
          !this.integrationComponent.chart_type ||
          !this.integrationComponent?.integrationsSettings?.integration_id ||
          !this.integrationComponent?.integrationsSettings?.event_id
        );
      },
      getPredefinedApplications() {
        return (this.integrations || []).filter((e) => e.app_type == 'PRE_DEFINED');
      },
      allIntegrationGlobalFilters() {
        return this.returnGlobalIntegrationFilters(this.customDashboardData);
      },
    },
    async backToCustom() {
      let query = this.getNavigationQuery(this.$route.query);
      let UrlPath = '';
      UrlPath = '/custom/';
      this.$router.push({
        path: UrlPath,
        query: query,
      });
      this.goBackToCustom = false;
    },
    async mounted() {
      this.session_id = `${this.getActiveWorkspace.company_id}#${this.getAuthenticatedUser._id}`;
      if (this.getIsMobile) {
        this.$message.warning('dashboard edit is not allowed in small screens');
        this.$router.push({ path: '/custom/dashboard-list' });
      }
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      if (this.$route.name == 'entity-custom-dashboard-config') {
        this.isEntityDashboard = true;
      }
      if (this.$route.params && this.$route.params.role_id) {
        this.role_id = this.$route.params.role_id;
      }
      await this.getNecessaryInfo();
      this.componentDataFetched = true;
      await this.checkUrlType();
      this.getCompanyInfo();
      this.allFormbuilders = await this.fetchAllFormbuilders();
    },
    watch: {
      selectedMulCustomFilterEntity() {
        this.updateMatchingFieldKeys();
      },
      isCustomization(val) {
        if (val) {
          const entityId = this.selectedEntityData || this.selectedEntityRelationalData;
          this.loadCustomizations(entityId);
        }
      },
    },
    methods: {
      checkUniqueConnectionComponents() {
        const uniqueComponents = new Set();
        const components = this.getSingleDashboardData?.components;
        components?.forEach((comp) => {
          if (comp.data_source === 'INTEGRATIONS' && comp.integrationsSettings?.integration_id) {
            uniqueComponents.add(comp.integrationsSettings.integration_id);
          }
        });
        return Array.from(uniqueComponents);
      },

      async getIntegrations() {
        try {
          let configuredConnetions = this.checkUniqueConnectionComponents();
          const connectionInfos = await Promise.allSettled(
            configuredConnetions.map(async (connection_id) => {
              const result = await postAPICall(
                'GET',
                `/integrations/service/get-tokens-by-connection/${connection_id}`
              );
              return result?.data;
            })
          );
          const successfulConnections = connectionInfos
            .filter((result) => result.status === 'fulfilled')
            .map((result) => result.value);
          return successfulConnections || [];
        } catch (err) {
          console.log('Integration-connection-err', err);
        }
      },
      async loadCustomizations(entity_id) {
        this.customizationOptions = await fetchAllEntityCustomizationsByEntity(entity_id);
      },
      optionsChanged(options) {
        while (this.pieChartFieldOptionsColors.length < options.length) {
          this.pieChartFieldOptionsColors.push('#FFFFFF');
        }
        this.pieChartFieldOptionsColors = this.pieChartFieldOptionsColors.slice(0, options.length);
      },
      getOptionLabel(option) {
        return this.getLabel(
          this.pieChartFieldEntityValues.find((dt) => dt._id == option),
          this.pieChartFieldEntityValues.findIndex((dt) => dt._id == option),
          this.pieChartFieldEntity
        );
      },
      updateFormRules(data) {
        if (data.index == -1) {
          this.colorRules.push(data);
        } else {
          this.colorRules[data.index] = { ...data };
        }
      },
      deleteFormRules(index) {
        this.colorRules.splice(index.index, 1);
      },
      async openColorRulesDialog() {
        this.colorRulesDialogVisible = true;
        let fields = await this.fetchEntityDetails(this.schedulerEntity, true);
        this.colorRulesFields = fields.map((fd) => {
          fd.key = fd.template_key;
          return fd;
        });
      },
      async fetchChartData() {
        if (!this.userPrompt.trim()) {
          this.$message.error('Please enter a valid prompt!');
          return;
        }
        const payload = {
          session_id: this.session_id,
          entity_id: this.selectedEntityData,
          query: this.userPrompt,
        };
        this.chartType = '';
        this.pieChartField = [];
        this.pieChartFieldSelectOptions = [];
        this.loading = true;

        try {
          const response = await axios.post(
            appConfig.AI_BASE_KODEFAST_URL + '/custom1_charts/',
            payload
          );

          const chartData = response.data;
          if (chartData) {
            this.chartComponentName = chartData.enter_component_name;
            this.chartType = chartData.chart_type.toUpperCase();
            this.pieChartField = chartData.select_field;
            if (Array.isArray(chartData.select_options)) {
              this.pieChartFieldSelectOptions.push(...chartData.select_options);
              this.pieChartFieldOptions = [...this.pieChartFieldSelectOptions];
            }
            this.chartSelectedFilter = chartData.filter_id;
            this.chartIcon = chartData.icon_name;
            this.sum_fields = chartData.show_total;
            this.pieChartFieldGroupBy = chartData.group_by;
            this.date_filter_field = chartData.apply_date_filter;

            if (chartData.select_field) {
              await this.fetchFieldOptionsForChart(chartData.select_field);
            }
          }

          this.$message.success('Data fetched successfully!');
          this.loading = false;
        } catch (error) {
          this.$message.error('Failed to fetch data. Please try again.');
          this.loading = false;
        }
      },
      isPresentInFormbuilder(row) {
        let entity_id = row?.field?.split('#')[0];
        let found = false;
        this.allFormbuilders.forEach((form) => {
          if (form?.is_approval_form) {
            form?.steps.forEach((step) => {
              if (step?.type == 'ENTITY' && step?.entity == entity_id) {
                found = true;
              }
            });
          }
        });
        return found;
      },
      updateFormbuilderData(formbuilderId, index) {
        let selectedFormbuilder = this.allFormbuilders.find(
          (f) => f._id == formbuilderId.split('#')[0]
        );
        this.notifications[index].is_anonymous =
          selectedFormbuilder?.form_builders_owner == 'ANONYMOUS' ? true : false;
      },
      async fetchSubGroupFilters() {
        this.schedulerEntitySubGroupsData = [];
        await Promise.all(
          this.schedulerEntitySubGroups.map(async (fl) => {
            let field = this.schedulingEntityFields.find((e) => e.template_key == fl);
            if (field?.entity_id) {
              let filters =
                this.entityFiltersMapping[field.entity_id] ||
                (await fetchAllEntityFiltersByEntity({
                  entityId: field.entity_id,
                }));
              this.entityFiltersMapping[field.entity_id] = filters;
              this.schedulerEntitySubGroupsData.push({
                label: field.label,
                entity_id: field.entity_id,
                filters: filters,
                key: fl,
              });
            }
          })
        );
      },
      checkAndAddGlobalFilters(stats) {
        let filters = [];

        stats.forEach((stat) => {
          if (stat?.apply_global_filter && stat?.global_filters && stat.global_filters.length) {
            let integration = this.getPredefinedApplications.find(
              (e) => e?._id == stat?.integration_id
            );

            stat.global_filters.forEach((gl) => {
              let existedFilter = filters.find(
                (fl) => fl.integration_id == stat.integration_id && fl?.dependency == gl
              );

              if (!existedFilter && integration?.connection_id) {
                filters.push({
                  connection_id: integration.connection_id,

                  dependency: gl,

                  default_value: integration.dependencies?.[gl] || '',

                  appName: integration.application,

                  type: 'INTEGRATION_FILTER',
                  integration_id: stat.integration_id,
                });
              }
            });
          }
        });

        this.customDashboardData['allIntegrationFilters'] = [...filters];
      },
      getSchedulingEntityIds(types, property) {
        return this.schedulingEntityFields
          .filter((e) => types.includes(e.input_type))
          .flatMap((e) => e[property]);
      },
      getEntityFields(entity_id, type) {
        let selectedEntity = this.getAllEntitiesData.find((e) => e._id == entity_id);
        let fields = [];
        (selectedEntity || []).templates.forEach((t) => {
          let temp = this.allTemplates.find((e) => e._id == t.template_id);
          fields = [
            ...fields,
            ...(temp.sections?.[0]?.fields || []).map((f) => {
              f.template_key = temp._id + '#' + f.key;
              return f;
            }),
          ];
        });
        if (type == 'RESOURCE') {
          this.resourceEntityFields = [...fields];
        } else if (type == 'JOB') {
          this.jobEntityFields = [...fields];
        } else {
          this.schedulingEntityFields = [...fields];
        }
      },
      async fetchSchedulerEntityFilters(entityId) {
        if (!entityId) return;

        this.schedulerEntityFilters = [];
        this.selectedSchedulerFilter = '';
        // this.loading = true;

        try {
          const filters = await fetchAllEntityFiltersByEntity({ entityId });
          this.schedulerEntityFilters = filters || [];
        } catch (e) {
          console.error('Failed to fetch scheduler entity filters', e);
          this.schedulerEntityFilters = [];
        }

        // this.loading = false;
      },
      resetConfig() {
        this.gaugeChartNumerator = {
          display_type: 'count',
        };
        this.gaugeChartDenominator = {
          display_type: 'count',
        };
        // this.gaugeChartCustomization = {
        //   delemeters: "33, 66",
        //   delemeterColors: ["#f56c6c", "#e6a23c", "#67c23a"],
        // };
        this.gaugeFilters = [];
        this.notifications = [];
        this.componentName = '';
        this.selectedRelationalFilter = 'login_user';
        this.editIndex = -1;
        this.configModal = false;
      },
      async isRelationshipEntityChanged(entity_id, index) {
        let entityId = entity_id.includes('#')
          ? entity_id.split('#')[1]
          : entity_id.includes('@')
            ? entity_id.split('@')[0]
            : entity_id;
        this.notifications[index].entity_id = entityId;
        await this.notificationEntityChanged(entityId, index);
      },
      async isRelationshipChanged(type) {
        switch (type) {
          case 'NUMERATOR':
            this.gaugeChartNumerator.entity_id = this.gaugeChartNumerator.relationship_id.includes(
              '#'
            )
              ? this.gaugeChartNumerator.relationship_id.split('#')[1]
              : this.gaugeChartNumerator.relationship_id;
            await this.fetchGaugeChartDetails('NUMERATOR');
            break;
          case 'DENOMINATOR':
            this.gaugeChartDenominator.entity_id =
              this.gaugeChartDenominator.relationship_id.includes('#')
                ? this.gaugeChartDenominator.relationship_id.split('#')[1]
                : this.gaugeChartDenominator.relationship_id;
            await this.fetchGaugeChartDetails('DENOMINATOR');
            break;
        }
      },
      getDelemeterRangeLabel(index) {
        let delemeters = this.gaugeChartCustomization.delemeters.split(',');
        switch (index) {
          case 0:
            return `0 - ${delemeters[index]}`;
          case delemeters.length:
            return `${delemeters[index - 1]} - 100`;
          default:
            return `${delemeters[index - 1]} - ${delemeters[index]}`;
        }
      },
      customizationChanged() {
        let splitArrayLength = this.gaugeChartCustomization.delemeters.split(',').length;
        if (this.gaugeChartCustomization.delemeters == '') {
          splitArrayLength = 0;
        }
        const desiredArrayLength = splitArrayLength + 1;
        while (this.gaugeChartCustomization.delemeterColors.length > desiredArrayLength) {
          this.gaugeChartCustomization.delemeterColors.pop();
        }
        while (this.gaugeChartCustomization.delemeterColors.length < desiredArrayLength) {
          this.gaugeChartCustomization.delemeterColors.push('#ffffff');
        }
      },
      changeIcon(index) {
        this.iconEditIndex = index;
        this.iconPickerdialogVisible = true;
      },
      setIconData(selectedIcon) {
        if (this.selectedComponentType == 'CHART') {
          if (this.customDashboardData.isFromIntegrations) {
            this.integrationComponent.chartIcon = selectedIcon;
          } else {
            this.chartIcon = selectedIcon;
          }
        } else {
          this.notifications[this.iconEditIndex].icon = selectedIcon;
        }
        this.iconPickerdialogVisible = false;
      },
      async editNotifications(index) {
        this.selectedComponentType = 'NOTIFICATIONS';
        this.configModal = true;
        this.editIndex = index;
        let component = this.customDashboardData.allTableComponents[index];
        this.notifications = (component.notifications || []).map((n) => ({
          ...n,
          redirect: n.redirect !== undefined ? n.redirect : true,
          customization: n.customization !== undefined ? n.customization : '',
        }));
        this.componentName = component.component_name;
        this.selectedRelationalFilter = component.selectedRelationalFilter;
        if (this.notifications) {
          this.notifications.forEach((row, i) => {
            if (row.relationship_id) {
              this.loadCustomizations(row.relationship_id).then((options) => {
                this.$set(this.notifications[i], 'customizationOptions', options);
              });
            }
          });
        }
        await Promise.all(
          this.notifications.map((n, i) => this.notificationEntityChanged(n.entity_id, i))
        );
      },
      async notificationEntityChanged(entityId, index) {
        this.notifications[index].refresh = true;
        if (!this.entityFiltersMapping?.[entityId]?.length) {
          let filters = await fetchAllEntityFiltersByEntity({
            entityId: entityId,
          });
          this.entityFiltersMapping[entityId] = [...filters];
        }
        this.notifications[index].refresh = false;
      },
      deleteNotification(index) {
        this.notifications.splice(index, 1);
      },
      addNewNotification() {
        this.notifications.push({
          type: 'IN_APP_NOTIFICATIONS',
          entity_id: '',
          formbuilder_id: '',
          events: ['ADDED', 'UPDATED', 'DELETED'],
          formBuilderEvents: ['FILLED', 'APPROVED', 'REJECTED'],
          filter: '',
          keyIndex: this.getRandomKey(),
          refresh: false,
          custom_message: '',
          background_color: '#FFFFFF',
          icon: 'dashboard',
          heading: '',
          is_anonymous: false,
          redirect: true,
          customization: '',
        });
      },
      addGaugeFilter() {
        this.gaugeFilters.push({
          type: 'ENTITY',
          entity_id: '',
          as: 'RELATIONSHIP',
          numerator: true,
          denominator: true,
        });
      },
      removeGaugeFilter(index) {
        this.gaugeFilters.splice(index, 1);
      },
      disableNotificationSave() {
        if (
          this.componentName == '' ||
          !this.notifications.length ||
          this.notifications.filter(
            (n) =>
              (n.entity_id == '' && n.formbuilder_id == '') ||
              (n.heading == '' && n.formbuilder_id == '') ||
              (n.heading == '' && n.entity_id != '' && n.formbuilder_id == '') ||
              n.custom_message == ''
          ).length ||
          this.notifications.filter(
            (n) =>
              (n.type == 'IN_APP_NOTIFICATIONS' &&
                !n.events.length &&
                !n.formBuilderEvents.length) ||
              (n.type == 'EVENT_NOTIFICATIONS' && n.filter == '')
          ).length
        ) {
          return true;
        }
        return false;
      },
      disableGaugeSave() {
        if (
          this.gaugeChartNumerator.entity_id == '' ||
          this.gaugeChartDenominator.entity_id == '' ||
          this.componentName == '' ||
          (this.gaugeChartNumerator.display_type != 'count' &&
            this.gaugeChartNumerator.sum_field == '') ||
          (this.gaugeChartDenominator.display_type != 'count' &&
            this.gaugeChartDenominator.sum_field == '')
        ) {
          return true;
        }
        return false;
      },
      saveNotifications() {
        if (this.editIndex > -1) {
          this.refreshComponents = true;
          this.customDashboardData.allTableComponents[this.editIndex] = {
            ...this.customDashboardData.allTableComponents[this.editIndex],
            notifications: (this.notifications || []).map((n) => ({
              ...n,
              redirect: n.redirect !== undefined ? n.redirect : true,
              customization: n.customization !== undefined ? n.customization : '',
            })),
            component_name: this.componentName,
            selectedRelationalFilter: this.selectedRelationalFilter,
          };
          setTimeout(() => {
            this.refreshComponents = false;
          }, 500);
          this.resetConfig();
        }
        this.configModal = false;
      },
      saveGaugeChart() {
        if (this.editIndex > -1) {
          this.refreshComponents = true;
          this.customDashboardData.allTableComponents[this.editIndex] = {
            ...this.customDashboardData.allTableComponents[this.editIndex],
            ...{
              numerator: this.gaugeChartNumerator,
              denominator: this.gaugeChartDenominator,
              component_name: this.componentName,
              filters: this.gaugeFilters,
              customization: this.gaugeChartCustomization,
            },
          };
          this.resetConfig();
          setTimeout(() => {
            this.refreshComponents = false;
          }, 500);
        }
        this.configModal = false;
      },
      async editGauge(index) {
        this.selectedComponentType = 'GAUGE_CHART';
        this.configModal = true;
        this.editIndex = index;
        let component = this.customDashboardData.allTableComponents[index];
        this.gaugeChartNumerator = { ...component.numerator };
        this.gaugeChartDenominator = { ...component.denominator };
        this.componentName = component.component_name;
        this.gaugeFilters = component?.filters || [];
        this.gaugeChartCustomization = component?.customization || {
          delemeters: '33, 66',
          delemeterColors: ['#f56c6c', '#e6a23c', '#67c23a'],
          showLegends: true,
          showExpand: true,
          ...component?.customization,
        };
        if (!('showLegends' in this.gaugeChartCustomization)) {
          this.$set(this.gaugeChartCustomization, 'showLegends', true);
        }
        if (!('showExpand' in this.gaugeChartCustomization)) {
          this.$set(this.gaugeChartCustomization, 'showExpand', true);
        }
        await Promise.all([
          this.fetchGaugeChartDetails('NUMERATOR'),
          this.fetchGaugeChartDetails('DENOMINATOR'),
        ]);
      },
      async fetchGaugeChartDetails(type) {
        await Promise.all([this.fetchGaugeEntityFields(type), this.fetchGaugeFilters(type)]);
      },
      async fetchGaugeEntityFields(type) {
        let fields;
        if (type == 'NUMERATOR') {
          this.numeratorFieldsLoading = true;
          this.numeratorEntityFields = [];
          if (this.gaugeChartNumerator?.entity_id != '') {
            fields = await this.fetchEntityDetails(this.gaugeChartNumerator.entity_id, true);
            this.numeratorEntityFields = [
              ...fields.filter(
                (fd) =>
                  ['NUMBER', 'CURRENCY', 'AGGREGATE_FUNCTION'].includes(fd.inputType) ||
                  ['NUMBER, CURRENCY'].includes(fd.result_type)
              ),
            ];
          }
          this.numeratorFieldsLoading = false;
        } else if (type == 'DENOMINATOR') {
          this.denominatorFieldsLoading = true;
          this.denominatorEntityFields = [];
          if (this.gaugeChartDenominator?.entity_id != '') {
            fields = await this.fetchEntityDetails(this.gaugeChartDenominator.entity_id, true);
            this.denominatorEntityFields = [
              ...fields.filter(
                (fd) =>
                  ['NUMBER', 'CURRENCY', 'AGGREGATE_FUNCTION'].includes(fd.inputType) ||
                  ['NUMBER, CURRENCY'].includes(fd.result_type)
              ),
            ];
          }
          this.denominatorFieldsLoading = false;
        }
      },
      async fetchGaugeFilters(type) {
        let filters;
        if (type == 'NUMERATOR') {
          this.numeratorFiltersLoading = true;
          this.numeratorFiters = [];
          if (this.gaugeChartNumerator?.entity_id != '') {
            if (this.entityFiltersMapping?.[this.gaugeChartNumerator.entity_id]?.length) {
              filters = [...this.entityFiltersMapping[this.gaugeChartNumerator.entity_id]];
            } else {
              filters = await fetchAllEntityFiltersByEntity({
                entityId: this.gaugeChartNumerator.entity_id,
              });
              this.entityFiltersMapping[this.gaugeChartNumerator.entity_id] = [...filters];
            }
            this.numeratorFiters = [...filters];
          }
          this.numeratorFiltersLoading = false;
        } else if (type == 'DENOMINATOR') {
          this.denominatorFiltersLoading = true;
          this.denominatorFilters = [];
          if (this.gaugeChartDenominator?.entity_id != '') {
            if (this.entityFiltersMapping?.[this.gaugeChartDenominator.entity_id]?.length) {
              filters = [...this.entityFiltersMapping[this.gaugeChartDenominator.entity_id]];
            } else {
              filters = await fetchAllEntityFiltersByEntity({
                entityId: this.gaugeChartDenominator.entity_id,
              });
              this.entityFiltersMapping[this.gaugeChartDenominator.entity_id] = [...filters];
            }
            this.denominatorFilters = [...filters];
          }
          this.denominatorFiltersLoading = false;
        }
      },
      backToCustom() {
        this.$router.go(-1);
        this.goBackToCustom = false;
      },
      // async fetchEntityDetails(
      //   id,
      //   includeLabel = false,
      //   includeSlugKey = false,
      //   include_data_tables = false,
      //   ogLabel = false
      // ) {
      //   let getChildEntityDataById = await fetchEntityById(id);
      //   // await this.$store.dispatch("entities/fetchChildEntityById", id);
      //   let allFields = [];
      //   if (getChildEntityDataById && getChildEntityDataById.templates) {
      //     getChildEntityDataById.templates.forEach((template) => {
      //       if (template?.templateInfo?.sections[0]?.fields) {
      //         allFields = [
      //           ...allFields,
      //           ...this.getTemplateFieldsInfo(
      //             template?.templateInfo,
      //             includeLabel,
      //             includeSlugKey,
      //             include_data_tables,
      //             ogLabel
      //           ),
      //         ];
      //       }
      //     });
      //     return allFields;
      //   }
      // },
      async getCompanyInfo() {
        this.loading = true;
        try {
          await this.$store.dispatch('company/fetchCompany', this.getActiveWorkspace.company_id);
          if (this.getCompanyDetails) {
            this.brandingInfo = {
              ...this.getCompanyDetails,
            };
            await Promise.all([this.applyTheme()]);
            this.loading = false;
          }
        } catch (e) {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: e,
          });
        }
      },
      async applyTheme() {
        // Apply theme using company info
        // Ensure that this.companyInfo is set before applying theme
        document.documentElement.style.setProperty(
          '--primary-color',
          this.getCompanyDetails.dialog_header_color
        );
        document.documentElement.style.setProperty(
          '--primary-contrast-color',
          this.getCompanyDetails.dialog_header_text_color
        );
        document.documentElement.style.setProperty(
          '--sidemenu-background-color',
          this.getCompanyDetails.sidemenu_background
        );
        document.documentElement.style.setProperty(
          '--sidemenu-text-color',
          this.getCompanyDetails.sidemenu_text
        );
        const primaryColor = getComputedStyle(document.documentElement)
          .getPropertyValue('--primary-color')
          .trim();
        const lighterPrimaryColor = chroma(primaryColor).brighten(0.5).hex();
        const darkerPrimaryColor = chroma(primaryColor).darken(0.5).hex();
        document.documentElement.style.setProperty('--darker-primary-color', darkerPrimaryColor);
        document.documentElement.style.setProperty('--lighter-primary-color', lighterPrimaryColor);
        // document.documentElement.style.setProperty('--Hover-color-inputfield', this.companyInfo.menubackground);
        // document.documentElement.style.setProperty('--text-secondary-color', 'white');

        const secondaryColor = getComputedStyle(document.documentElement)
          .getPropertyValue('--secondary-color')
          .trim();

        const darkerSecondaryColor = chroma(secondaryColor).brighten(0.3).hex();

        document.documentElement.style.setProperty(
          '--darker-secondary-color',
          darkerSecondaryColor
        );
      },
      getTemplateFieldsInfo(
        data,
        includeLabel,
        includeSlugKey = false,
        include_data_tables = false,
        ogLabel = false
      ) {
        let fields = [];
        data.sections.forEach((e) => {
          fields = [...fields, ...e.fields];
        });

        fields = fields.map((e) => {
          e.template_id = data._id;
          e.template_key = data._id + '#' + e.key;
          e.template_name = data.name;
          if (includeLabel) {
            e.label = data.name + ' - ' + e.label;
          } else if (!ogLabel) {
            e.label = data.slug + '#' + e.key;
          }
          if (includeSlugKey) {
            e.key = data.slug + '_' + e.key;
          }
          return e;
        });
        if (include_data_tables) {
          //have to check data table fields
          let dataTableFields = fields.filter((e) => e?.inputType == 'DATA_TABLE');
          if (dataTableFields && dataTableFields.length) {
            dataTableFields.forEach((fl) => {
              if (fl?.data_table_columns) {
                fields = [
                  ...fields,
                  ...fl?.data_table_columns.map((e) => {
                    e.data_table_key = fl.key;
                    e.template_id = data._id;
                    e.label = fl.label + '-' + e.label;
                    e.all_duplicate_rules = fl.all_duplicate_rules;
                    e.duplicate_query_type = fl.duplicate_query_type;
                    if (fl.input_type == 'ENTITY_VARIABLE' && fl?.relationship_key) {
                      e.table_relationship_key = fl.relationship_key;
                    }
                    if (includeLabel) {
                      e.label = data.name + ' - ' + e.label;
                    } else {
                      e.label = data.slug + '#' + e.key;
                    }
                    if (includeSlugKey) {
                      e.key = data.slug + '_' + e.key;
                    }
                    e.template_id = data._id;
                    e.template_key = data._id + '#' + e.key;
                    e.template_name = data.name;
                    e['isDataTableField'] = true;
                    // if (include_data_table_key) {
                    //   e.key = e.data_table_key + "/" + e.key;
                    // }
                    return e;
                  }),
                ];
              }
            });
          }
          fields = fields.filter((e) => {
            return e.inputType != 'DATA_TABLE';
          });
        }
        return fields;
      },
      openTableColumsModalClose() {
        this.openTableColumsModal = false;
      },
      isActionDisabled(index, selectedAction) {
        if (index > 0 && this.tableDatas[index - 1].action === selectedAction) {
          return true;
        }
        return false;
      },
      isFieldDisabled(field) {
        let fieldSelected = false;
        let selectedFirstField;
        this.info.map((e) => {
          if (e.field) {
            fieldSelected = true;
            selectedFirstField = e;
          }
        });
        if (!fieldSelected) {
          this.selectedFieldType = '';
          this.dateTimeFieldObject = null;
          this.shouldDisplayInput = false;
          return false;
        }
        if (!this.dateTimeFieldObject) {
          let key = selectedFirstField.field;
          this.dateTimeFieldObject = this.allDateTimeFields.find((e) => e.template_key == key);
          if (this.dateTimeFieldObject && this.dateTimeFieldObject.isDataTableField) {
            this.selectedFieldType = 'data_table';
            this.shouldDisplayInput = true;
            this.displayAutoLogout = false;
          } else {
            this.selectedFieldType = 'normal';
            this.shouldDisplayInput = false;
            this.displayAutoLogout = true;
          }
        }

        if (!this.dateTimeFieldObject) {
          return false;
        }
        if (
          this.selectedFieldType == 'data_table' &&
          field.isDataTableField &&
          this.info.findIndex((ex) => ex.field == field.template_key) == -1
        ) {
          return false;
        } else if (
          this.selectedFieldType == 'normal' &&
          !field.isDataTableField &&
          this.info.findIndex((ex) => ex.field == field.template_key) == -1
        ) {
          return false;
        } else {
          return true;
        }
      },
      async addSubGroupCount() {
        if (this.tableFieldSubGroupBy) {
          this.tableFieldGroupByFields.push({
            key: 'count',
            name: 'Count',
            type: 'count',
            sub_group: true,
          });
          await this.getSelectedFieldOptions(this.tableFieldSubGroupBy);
        }
      },
      resetEventModal() {
        this.openNewEventLoading = false;
        this.openNewEventModal = false;
        this.tableData = [];
        this.calenderDateField = [];
        this.centerDialogVisible = false;
      },
      CenterDialogVisibleClose() {
        this.centerDialogVisible = false;
      },
      loginPopUpClose() {
        this.centerLoginsDialogVisible = false;
        this.loginsDialogVisible = false;
      },
      saveTableGroupBy() {
        this.tableFieldGroupByFields = [];
        this.tableFieldGroupByFields = [...this.tableFieldGroupByFieldsModal];
        this.openTableColumsModal = false;
      },
      fillLabel(key, index) {
        if (key) {
          if (key == 'count') {
            this.tableFieldGroupByFieldsModal[index]['name'] = 'Count';
          } else {
            let field = this.getTotalFields.find((e) => e.key == key),
              group_by_fields = ['SELECT', 'ENTITY', 'MULTI_SELECT'];
            this.tableFieldGroupByFieldsModal[index]['type'] =
              field && group_by_fields.indexOf(field.inputType) != -1 ? 'groupby' : 'sum';
            this.tableFieldGroupByFieldsModal[index]['name'] =
              field && field.label ? field.label : '';
          }
        }
      },
      addNewColumn() {
        this.tableFieldGroupByFieldsModal.push({
          name: '',
          key: '',
          type: '',
        });
      },
      openTableColums() {
        this.tableFieldGroupByFieldsModal = [];
        this.tableFieldGroupByFieldsModal = [...this.tableFieldGroupByFields];
        this.openTableColumsModal = true;
      },
      getCurrenEntityFilter(id) {
        if (id) {
          let found = this.allEntityFilters.find((e) => e.entity_id == id);
          if (found) {
            return found.filters;
          }
          return [];
        }
        return [];
      },
      getEntityFilters(row) {
        if (
          row &&
          row.includes('#') &&
          row.split('#')[0] &&
          !this.allEntityFilters[row.split('#')[0]]
        ) {
          let field = this.getTemplateDateFields.find((e) => e.key == row);
          let index = this.tableData.findIndex((e) => e.field == row);
          if (field?.inputType) {
            this.tableData[index]['inputType'] = field.inputType;
          }
          if (field?.is_relational_field) {
            this.tableData[index]['is_relational_field'] = field.is_relational_field;
          }
          if (field?.is_nested_relational_field || field?.is_nested_relational_field == 'true') {
            this.$set(this.tableData[index], 'is_nested_relational_field', true);
            this.$set(this.tableData[index], 'nested_entity_info', field.nested_entity_info);
            // console.log("the nested relational",field.is_nested_relational_field, field.nested_entity_info, this.tableData[index],index)
          }
          if (
            index > -1 &&
            (!this.tableData[index].custom_message ||
              (typeof this.tableData[index].custom_message == 'object' &&
                Object.keys(this.tableData[index].custom_message).length == 0))
          ) {
            let entity = (this.getAllEntities.data || []).find((e) => e._id == row.split('#')[0]);
            if (entity?.primaryFields && entity?.primaryFields[0]) {
              let temp = (this.allTemplates || []).find(
                (e) => e._id == entity?.primaryFields[0].template_id
              );
              this.tableData[index]['custom_message'] = {
                type: 'doc',
                content: [
                  {
                    type: 'paragraph',
                    content: [
                      {
                        type: 'mention',
                        attrs: {
                          id: temp?.slug + '#' + entity?.primaryFields[0].key,
                          label: null,
                        },
                      },
                      {
                        type: 'text',
                        text: ' ' + row.split('#')[2],
                      },
                    ],
                  },
                ],
              };
            }
          }

          this.fetchEntityFilters(row.split('#')[0]);
          this.isPresentInFormbuilder(row);
        }
      },
      async fetchEntityFilters(entityId) {
        await this.$store.dispatch('filters/fetchAllEntityFilters', {
          entityId: entityId,
        });
        if (this.getAllEntityFilters) {
          this.allEntityFilters.push({
            entity_id: entityId,
            filters: this.getAllEntityFilters,
          });
        }
      },
      insertCalendarFields() {
        if (this.tableData.length > 0) {
          this.calenderDateField = [...this.tableData];
          this.tableData = [];
          this.centerDialogVisible = false;
          this.insertComponent();
        } else {
          // console.log("add");
        }
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      addNewRow() {
        let field = {
          field: '',
          custom_message: {},
          show_every_year: false,
          filter_id: '',
          is_relational_field: false,
          is_nested_relational_field: false,
          nested_entity_info: '',
          inputType: 'DATE',
          color: '#f754b9',
          applyBackground: false,
          show_formbuilder_data: false,
        };
        this.refresh = true;
        this.tableData.push(field);
        setTimeout(() => {
          this.refresh = false;
        }, 500);
      },
      displayPopup() {
        if (this.calenderDateField && this.calenderDateField.length) {
          this.tableData = [...this.calenderDateField];
        }
        this.addNewRow();
        this.centerDialogVisible = true;
      },
      displayLoginsPopup() {
        this.centerLoginsDialogVisible = true;
      },
      displayNewLoginsPopup() {
        this.loginsDialogVisible = true;
      },
      async getLoginEntityDateFields() {
        if (this.selectedLoginEntity) {
          this.allEntityFields = await this.fetchEntityDetails(
            this.selectedLoginEntity,
            true,
            false,
            true
          );
          if (this.isEntityDashboard) {
            this.loginEntityFilters = await fetchAllEntityFiltersByEntity({
              entityId: this.$route.params.entityId,
            });
          }
          this.allDateTimeFields = this.allEntityFields.filter(
            (e) => e.input_type == 'TIME' || e.input_type == 'DATE' || e.input_type == 'DATE_TIME'
          );
          this.allEntityFields;
          this.allLocationFields = this.allEntityFields.filter((e) => e.input_type == 'LOCATION');
          this.entityField = this.allEntityFields.filter((e) => e.input_type == 'ENTITY');
          this.textField = this.allEntityFields.filter((e) => e.input_type == 'SINGLE_LINE_TEXT');
        } else if (this.isEntityDashboard && this.selectedLoginEntityRelationalData) {
          this.allEntityFields = await this.fetchEntityDetails(
            this.selectedLoginEntityRelationalData,
            true,
            false,
            true
          );
          if (this.isEntityDashboard) {
            this.loginEntityFilters = await fetchAllEntityFiltersByEntity({
              entityId: this.$route.params.entityId,
            });
          }
          this.allDateTimeFields = this.allEntityFields.filter(
            (e) => e.input_type == 'TIME' || e.input_type == 'DATE' || e.input_type == 'DATE_TIME'
          );
          this.entityField = this.allEntityFields.filter((e) => e.input_type == 'ENTITY');
          this.textField = this.allEntityFields.filter((e) => e.input_type == 'SINGLE_LINE_TEXT');

          console.log('Fields', this.allDateTimeFields, this.entityField, this.textField);
        }
      },
      saveLoginsData() {
        this.loginsDataDetails = [...this.info];
        this.info = [
          { component: 'Date', field: '' },
          { component: 'Login', field: '' },
          { component: 'Logout', field: '' },
          { component: 'Duration', field: '' },
        ];
        this.centerLoginsDialogVisible = false;
        this.loginsDialogVisible = false;
        this.insertComponent();
      },

      saveAttendanceData() {
        this.loginsDataDetails = [...this.attendance.new_attendance];
        this.centerLoginsDialogVisible = false;
        this.loginsDialogVisible = false;
        this.insertComponent();
      },
      getEntityDateFields() {
        this.getTemplateDateFields = [];
        if (this.selectedCalendarEntities.length) {
          this.selectedCalendarEntities.forEach((entity_id) => {
            const entity = (this.getAllEntities.data || []).find((e) => e._id == entity_id);
            const templateIds = (entity.templates || []).flatMap((e) => e.template_id);
            const entityTemplates = this.allTemplates.filter(
              (e) => templateIds.indexOf(e._id) !== -1
            );
            entityTemplates.forEach((e) => {
              let data = JSON.parse(JSON.stringify(e));
              this.getTemplateDateFields = [
                ...this.getTemplateDateFields,
                ...this.getTemplateFieldsByType(
                  data,
                  ['DATE', 'DATE_TIME', 'DATE_TIME_RANGE', 'DATE_RANGE'],
                  entity
                ),
              ];
            });
          });
        }
        if (this.selectedCalendarRelationEntities.length) {
          this.selectedCalendarRelationEntities.forEach((entity_id) => {
            const entity = (this.getAllEntities.data || []).find((e) => e._id == entity_id);
            const templateIds = (entity.templates || []).flatMap((e) => e.template_id);
            const entityTemplates = this.allTemplates.filter(
              (e) => templateIds.indexOf(e._id) !== -1
            );
            entityTemplates.forEach((e) => {
              let data = JSON.parse(JSON.stringify(e));
              let fields = this.getTemplateFieldsByType(
                data,
                ['DATE', 'DATE_TIME', 'DATE_TIME_RANGE', 'DATE_RANGE'],
                entity
              );
              fields = fields.map((el) => {
                el.is_relational_field = true;
                return el;
              });
              this.getTemplateDateFields = [...this.getTemplateDateFields, ...fields];
            });
          });
        }
        if (this.selectedCalendarNestedRelationEntities.length) {
          // console.log("this.selectedCalendarNestedRelationEntities", this.selectedCalendarNestedRelationEntities);
          this.selectedCalendarNestedRelationEntities.forEach((entityPair) => {
            let entity_id = entityPair.split('#')[1];
            const entity = (this.getAllEntities.data || []).find((e) => e._id == entity_id);
            const templateIds = (entity.templates || []).flatMap((e) => e.template_id);
            const entityTemplates = this.allTemplates.filter(
              (e) => templateIds.indexOf(e._id) !== -1
            );
            entityTemplates.forEach((e) => {
              let data = JSON.parse(JSON.stringify(e));
              let fields = this.getTemplateFieldsByType(
                data,
                ['DATE', 'DATE_TIME', 'DATE_TIME_RANGE', 'DATE_RANGE'],
                entity
              );
              fields = fields.map((el) => {
                el.is_nested_relational_field = true;
                el.nested_entity_info = entityPair;
                return el;
              });
              this.getTemplateDateFields = [...this.getTemplateDateFields, ...fields];
            });
          });
        }
      },
      switchPositions(evt) {
        if (
          evt &&
          typeof evt.oldIndex == 'number' &&
          typeof evt.newIndex == 'number' &&
          this.customDashboardData.allTableComponents[evt.oldIndex]
        ) {
          let data = JSON.parse(
            JSON.stringify(this.customDashboardData.allTableComponents[evt.oldIndex])
          );
          let data1 = JSON.parse(
            JSON.stringify(this.customDashboardData.allTableComponents[evt.newIndex])
          );
          data.order = evt.newIndex;
          data1.order = evt.oldIndex;
          this.customDashboardData.allTableComponents.splice(evt.oldIndex, 1, data1);
          this.customDashboardData.allTableComponents.splice(evt.newIndex, 1, data);
        }
      },

      getRandomKey() {
        return (Math.random() + 1).toString(36).substring(7);
      },
      async fetchFieldOptionsForChart(field) {
        await this.fetchFieldOptions(field);
      },
      tableUpdate(data) {
        this.customDashboardData.allTableComponents[data.index] = {
          ...data.data,
        };
      },
      async saveDashboard() {
        if (this.getIsMobile) {
          this.$message.warning('dashboard edit is not allowed in small screens');
          this.$router.push({ path: '/custom/dashboard-list' });
        }
        this.loading = true;
        // bus.$emit("fetch-all-stats", {});
        let params = {
          name: this.customDashboardData.name,
          components: [
            ...this.customDashboardData.allStatComponents,
            ...this.customDashboardData.allTableComponents,
            ...this.customDashboardData.allCustomFilters,
            ...this.customDashboardData.allMulCustomFilters,
            // ...this.customDashboardData.allIntegrationFilters,
          ],
          include_global_date_filter: this.customDashboardData.includeGlobalDateFilter,
          date_value: this.customDashboardData.date_value,
          Custom_date_value: this.customDashboardData.Custom_date_value,
          allow_user_change_order: this.customDashboardData.allowUserChangeOrder,
        };
        if (this.isEntityDashboard && this.customDashboardData.selectedRelationalFilter) {
          params['selectedRelationalFilter'] = this.customDashboardData.selectedRelationalFilter;
        }
        if (this.$route.params.entityId) {
          params = { ...params, ...{ entity_id: this.$route.params.entityId } };
        }
        if (this.$route.params.role_id) {
          params = { ...params, ...{ role_id: this.$route.params.role_id } };
        }
        let id = this.$route.params.dashboardId || this.$route.query.dashboardId;

        if (id) {
          await this.$store.dispatch('customDashboard/updateDashboard', {
            id: id,
            params: params,
          });
          if (this.getUpdateDashboardStatus) {
            if (this.getUpdateDashboardData?.data && !this.isEntityDashboard) {
              await updateCustomDashboardData(id, this.getUpdateDashboardData.data);
            }
            this.$notify({
              title: 'Success',
              message: 'Dashboard updated successfully',
              type: 'success',
            });
            this.goBack();
          } else {
            let msg =
              this.getUpdateDashboardError && this.getUpdateDashboardError.message
                ? this.getUpdateDashboardError.message
                : 'Error while editing dashboard';
            this.$notify({
              title: 'Error',
              message: msg,
              type: 'error',
            });
          }
        } else {
          await this.$store.dispatch('customDashboard/fetchCreateNewDashboard', params);
          if (
            this.getCreateNewDashboard &&
            this.getCreateNewDashboard._id &&
            !this.isEntityDashboard
          ) {
            await addSingleCustomDashboardToLocal(this.getCreateNewDashboard);
            this.$notify({
              title: 'Success',
              message: 'Dashboard updated successfully',
              type: 'success',
            });
            // this.$router.push({
            //   path: "/entity",
            // });
            this.goBack();
          } else if (
            this.isEntityDashboard &&
            this.getCreateNewDashboard &&
            this.getCreateNewDashboard._id
          ) {
            this.$notify({
              title: 'Success',
              message: 'Dashboard updated successfully',
              type: 'success',
            });
            if (this.$route.params.role_id) {
              this.$router.push({
                path: `/ap-user/custom-dashboards/${this.$route.params.entityId}/rbac`,
                query: { name: this.$route.query.name },
              });
            } else {
              this.$router.push({
                path: `/ap-user/custom-dashboards/${this.$route.params.entityId}`,
                query: { name: this.$route.query.name },
              });
            }
          } else {
            let msg =
              this.getCreateNewDashboardError && this.getCreateNewDashboardError.message
                ? this.getCreateNewDashboardError.message
                : 'Error while saving data';
            this.$notify({
              title: 'Error',
              message: msg,
              type: 'error',
            });
          }
        }
        this.loading = false;
      },
      expendTable(index) {
        if (this.expendedIndexs.indexOf(index) == -1) {
          this.customDashboardData.allTableComponents[index]['is_expand'] = true;
          this.expendedIndexs.push(index);
        } else {
          this.expendedIndexs.splice(this.expendedIndexs.indexOf(index), 1);
          this.customDashboardData.allTableComponents[index]['is_expand'] = false;
        }
      },
      deleteComponent(index) {
        this.refreshComponents = true;
        this.customDashboardData.allTableComponents.splice(index, 1);
        setTimeout(() => {
          this.refreshComponents = false;
        }, 500);
      },
      insertComponent() {
        if (this.selectedComponentType == 'CHART') {
          if (this.customDashboardData.isFromIntegrations) {
            this.insertIntegrationsComponent();
          } else {
            this.insertChartComponent();
            this.resetFormData();
          }
        } else if (this.selectedComponentType == 'CUSTOM_FILTER') {
          this.insertFilterComponent();
        } else if (this.selectedComponentType == 'CALENDAR') {
          this.insertCalendarComponent();
        } else if (this.selectedComponentType == 'CARD') {
          this.insertCardComponent();
        } else if (this.selectedComponentType == 'LOGINS') {
          this.insertLoginsComponent();
        } else if (this.selectedComponentType == 'ATTENDANCE') {
          this.insertLoginsComponent(true);
        } else if (this.selectedComponentType == 'ENTITY_VIEW') {
          this.insertEntityView();
        } else if (this.selectedComponentType == 'SCHEDULING') {
          this.insertScheduler();
        } else if (this.selectedComponentType == 'GAUGE_CHART') {
          this.insertGaugeChart();
        } else if (this.selectedComponentType == 'NOTIFICATIONS') {
          this.insertNotifications();
        } else if (this.selectedComponentType == 'MULTIPLE_CUSTOM_FILTER') {
          this.insertMulCustomFilter();
        }
        // else if (this.selectedComponentType == "GANTT_CHART"){
        //   this.insertGanttChart();
        // }
        else {
          this.insertTableComponent();
          this.resetFormData();
        }
        this.getComponentStatus();
      },
      insertNotifications() {
        this.customDashboardData.allTableComponents.push({
          component_name: this.componentName,
          notifications: this.notifications,
          type: 'NOTIFICATIONS',
          feature: 'NOTIFICATIONS',
          keyValue: this.getRandomKey(),
          order: this.customDashboardData.allTableComponents.length,
          isExpandTable: false,
          selectedRelationalFilter: this.customDashboardData.selectedRelationalFilter,
        });
        this.resetFormData();
      },
      insertCalendarComponent() {
        this.customDashboardData.allTableComponents.push({
          component_name: this.calendarName,
          entity_id: this.selectedEntityData,
          filter_id: '',
          type: 'CALENDAR',
          feature: 'ENTITY',
          icon: 'dashboard.svg',
          keyValue: this.getRandomKey(),
          order: this.customDashboardData.allTableComponents.length,
          selectedCalendarEntities: [
            ...this.selectedCalendarEntities,
            ...this.selectedCalendarRelationEntities,
            ...this.selectedCalendarNestedRelationEntities,
          ],
          calenderDateField: this.calenderDateField,
          allowOtherShowData: this.allowOtherShowData,
          is_relational_data:
            this.selectedCalendarRelationEntities && this.selectedCalendarRelationEntities.length
              ? true
              : false,
          is_nested_relational_data:
            this.selectedCalendarNestedRelationEntities &&
            this.selectedCalendarNestedRelationEntities.length
              ? true
              : false,
        });
        this.selectedCalendarNestedRelationEntities = [];
        this.selectedCalendarRelationEntities = [];
        this.selectedCalendarEntities = [];
        this.calenderDateField = [];
        this.calendarName = '';
      },
      insertScheduler() {
        this.customDashboardData.allTableComponents.push({
          component_name: this.schedulerComponentName,
          resource_entity: this.resourceEntity,
          scheduler_entity_date_field: this.schedulerEntityDateField,
          job_entity_time_field: this.jobEntityTimeField,
          resource_entity_time_field: this.resourceEntityTimeField,
          scheduler_entity_sub_groups: this.schedulerEntitySubGroups,
          scheduler_entity_sub_groups_filters: this.schedulerEntitySubGroupsFilters,
          job_entity: this.jobEntity,
          scheduler_entity: this.schedulerEntity,
          icon: 'dashboard.svg',
          type: 'SCHEDULING',
          feature: 'SCHEDULING',
          keyValue: this.getRandomKey(),
          order: this.customDashboardData.allTableComponents.length,
          isExpandTable: true,
          applyRelationship: this.applyRelationship,
          scheduler_entity_resource_label_field: this.schedulerEntityResourceLabelField,
          scheduler_entity_job_label_date_field: this.schedulerEntityJobLabelDateField,
          rules: this.colorRules,
          allow_multiple_slots: this.allowMultipleSlots,
          scheduler_entity_filter: this.selectedSchedulerFilter,
        });
        this.resetInsertScheduler();
      },
      resetInsertScheduler() {
        this.schedulerComponentName = '';
        this.resourceEntity = '';
        this.schedulerEntityDateField = '';
        this.jobEntityTimeField = '';
        this.resourceEntityTimeField = '';
        this.jobEntity = '';
        this.schedulerEntity = '';
        this.schedulerEntityJobLabelDateField = [];
        this.schedulerEntityResourceLabelField = [];
        this.schedulerEntityFilters = [];
        this.colorRules = [];
      },
      insertEntityView() {
        let selectedView = this.getAllEntityViews.data.find(
          (view) => view._id == this.selectedEntityView
        );
        this.customDashboardData.allTableComponents.push({
          component_name: selectedView.name,
          entity_view_id: this.selectedEntityView,
          icon: 'dashboard.svg',
          type: 'ENTITY_VIEW',
          feature: 'ENTITY_VIEW',
          keyValue: this.getRandomKey(),
          order: this.customDashboardData.allTableComponents.length,
          isExpandTable: false,
          is_relational_data: this.isRelationalData,
        });
        this.selectedEntityView = '';
      },
      insertGaugeChart() {
        this.customDashboardData.allTableComponents.push({
          component_name: this.componentName,
          numerator: this.gaugeChartNumerator,
          denominator: this.gaugeChartDenominator,
          icon: 'dashboard',
          type: 'GAUGE_CHART',
          feature: 'GAUGE_CHART',
          keyValue: this.getRandomKey(),
          order: this.customDashboardData.allTableComponents.length,
          isExpandTable: false,
          filters: this.gaugeFilters,
          customization: this.gaugeChartCustomization,
        });
        this.gaugeChartNumerator = {
          display_type: 'count',
        };
        this.gaugeChartDenominator = {
          display_type: 'count',
        };
        this.gaugeFilters = [];
        this.componentName = '';
      },
      // insertGanttChart() {
      //   this.customDashboardData.allTableComponents.push({
      //     component_name: "Gantt Chart",
      //     icon: "dashboard.svg",
      //     type: "GANTT_CHART",
      //     feature: "ENTITY",
      //     keyValue: this.getRandomKey(),
      //     isExpandTable: false,
      //     order: this.customDashboardData.allTableComponents.length,
      //   });

      // },
      insertChartComponent() {
        let entity_id = '';
        this.selectedEntityRelationalData;
        if (this.isEntityDashboard && this.selectedEntityRelationalData) {
          entity_id = this.selectedEntityRelationalData;
        } else {
          entity_id = this.selectedEntityData;
        }
        this.customDashboardData.allTableComponents.push({
          userPrompt: this.userPrompt,
          component_name: this.chartComponentName,
          chart_description: this.chartDescription,
          entity_id: entity_id,
          filter_id: '',
          type: 'CHART',
          chart_type: this.chartType,
          combinedData: this.combinedData,
          feature: 'ENTITY',
          icon: this.chartIcon,
          isExpandTable: false,
          pie_chart_field: this.pieChartField,
          pie_chart_field_options: this.pieChartFieldOptions,
          pie_chart_field_options_colors: this.pieChartFieldOptionsColors,
          pie_chart_field_group_by: this.pieChartFieldGroupBy,
          pie_chart_field_group_by_selected_options: this.pieChartFieldGroupBySelectedOptions,
          date_filter_field: this.date_filter_field,
          include_chart_total: this.includeChartTotal,
          sum_fields: this.sum_fields,
          keyValue: this.getRandomKey(),
          order: this.customDashboardData.allTableComponents.length,
          is_relational_data:
            this.isEntityDashboard && this.selectedEntityRelationalData ? true : false,
          chart_selected_filter: this.chartSelectedFilter,
          BarColor: this.BarColor,
          isStacked: this.isStacked,
          startFrom: this.startFrom,
          showLegend: true,
          showIcon: true,
          barOrientation: this.barOrientation,
          selectedCustomization: this.selectedCustomization,
          isCustomization: this.isCustomization,
          selectedRelationalFilter: this.customDashboardData.selectedRelationalFilter,
        });
        this.resetPieModel();
      },
      insertIntegrationsComponent() {
        let matchedComponent = this.customDashboardData.allTableComponents.find(
          (comp) => comp.keyValue === this.integrationComponent.keyValue
        );
        if (matchedComponent) {
          this.customDashboardData.allTableComponents.forEach((comp, index) => {
            if (comp.keyValue === matchedComponent.keyValue) {
              this.customDashboardData.allTableComponents[index] = this.integrationComponent;
            }
          });
          this.selectedComponentType == '';
          this.customDashboardData.isFromIntegrations = false;
        } else {
          this.integrationComponent['isExpandTable'] = false;
          this.integrationComponent['showLegend'] = true;
          this.integrationComponent['showIcon'] = true;
          this.integrationComponent['keyValue'] = this.getRandomKey();
          this.customDashboardData.allTableComponents.push(this.integrationComponent);
        }
        this.integrationComponent = {
          component_name: '',
          type: 'CHART',
          chart_type: '',
          feature: 'ENTITY',
          isNew: true,
          date_filter_field: '',
          ignore_year: false,
          selected_fields: [],
          send_notification: false,
          compare: false,
          sort_by: '',
          sort_order: 'asc',
          compare_with: 'one',
          data_source: 'INTEGRATIONS',
          integrationsSettings: {
            integration_id: '',
            event: null,
            event_id: '',
            dependencies: {},
            selectedFields: [],
            globalFilters: [],
            exisitingFilterComponent: '',
            radioFilter: '1',
          },
          BarColor: this.BarColor,
        };
      },
      async insertLoginsComponent(isFromAttendence = false) {
        let entity_id = '';
        if (this.isEntityDashboard && this.selectedLoginEntityRelationalData) {
          entity_id = this.selectedLoginEntityRelationalData;
        } else {
          entity_id = this.selectedLoginEntity;
        }
        this.customDashboardData.allTableComponents.push({
          component_name: isFromAttendence ? 'ATTENDANCE' : 'LOGINS',
          type: isFromAttendence ? 'ATTENDANCE' : 'LOGINS',
          entity_id: entity_id,
          filter_id: '',
          feature: 'ENTITY',
          icon: 'dashboard.svg',
          keyValue: this.getRandomKey(),
          isExpandTable: false,
          order: this.customDashboardData.allTableComponents.length,
          selectedLoginEntity: this.selectedLoginEntity,
          start_button: isFromAttendence ? this.attendance.start_button : this.start_button,
          end_button: isFromAttendence ? this.attendance.end_button : this.end_button,
          loginFilter: this.loginFilter,
          loginsDataDetails: this.loginsDataDetails,
          loginLogoutDropdownData: this.loginLogoutDropdownData,
          selectedEntityRelationalData: this.selectedLoginEntityRelationalData,
          is_relational_data:
            this.isEntityDashboard && this.selectedLoginEntityRelationalData ? true : false,
          Days: isFromAttendence ? this.attendance.Days : this.Days,
          auto_logout: this.auto_logout,
          user_field: isFromAttendence ? this.attendance.user_field : this.user_field,
          companyuser_field: isFromAttendence
            ? this.attendance.companyuser_field
            : this.companyuser_field,
          selectedLoginLocation: isFromAttendence
            ? this.attendance.companyuser_field
            : this.selectedLoginLocation,
          selectedLogoutLocation: isFromAttendence
            ? this.attendance.companyuser_field
            : this.selectedLogoutLocation,
          isDropdownVisible: isFromAttendence
            ? this.attendance.isDropdownVisible
            : this.isDropdownVisible,
          isGeoFenceRequired: isFromAttendence
            ? this.attendance.isGeoFenceRequired
            : this.isGeoFenceRequired,
          geoFenceCoordinates: isFromAttendence
            ? this.attendance.geoFenceCoordinates
            : this.geoFenceCoordinates,
          geoFenceRadius: isFromAttendence ? this.attendance.geoFenceRadius : this.geoFenceRadius,
          swipeConfig: this.swipeConfig,
          timeDuration: this.timeDuration,
        });
        this.selectedLoginEntity = '';
        this.start_button = '';
        this.end_button = '';
        this.loginsDataDetails = [];
        this.selectedLoginEntityRelationalData = '';
        this.Days = '';
        this.selectedLoginLocation = null;
        this.isDropdownVisible = false;
        this.isGeoFenceRequired = false;
        this.geoFenceRadius = null;
        ((this.geoFenceCoordinates = []), (this.selectedLogoutLocation = null));
        ((this.loginLogoutDropdownData = [
          { component: 'Login Dropdown', fields: [] },
          { component: 'Logout Dropdown', fields: [] },
        ]),
          (this.user_field = ''),
          (this.companyuser_field = ''),
          (this.timeDuration = false));
        ((this.swipeConfig = {
          show: true,
          label: 'View Swipes',
        }),
          (this.attendance = {
            loginFilter: '',
            start_button: '',
            end_button: '',
            isGeoFenceRequired: false,
            selectedLoginLocation: '',
            selectedLogoutLocation: '',
            geoFenceRadius: null,
            geoFenceCoordinates: [],
            user_field: '',
            companyuser_field: '',
            Days: '',
            isDropdownVisible: false,
            new_attendance: [
              { component: 'Swipe', key: 'swipe', type: 'DATE', field: '' },
              {
                component: 'Login Type',
                key: 'login_type',
                type: 'SELECT',
                field: '',
              },
              {
                component: 'Device Id',
                key: 'deviceId',
                type: 'TEXT',
                field: '',
              },
              {
                component: 'IP Address',
                key: 'ip_address',
                type: 'TEXT',
                field: '',
              },
              {
                component: 'Location (GEO)',
                key: 'geo_location',
                type: 'TEXT',
                field: '',
              },
              {
                component: 'Auth Type',
                key: 'auth_type',
                type: 'TEXT',
                field: '',
              },
              {
                component: 'Biometric Id',
                key: 'bio_id',
                type: 'Number',
                field: '',
              },
            ],
          }));

        if (this.auto_logout) {
          let params = {
            entityId: entity_id,
          };
          await this.$store.dispatch('entities/callCronForAutoLogout', params);
        }
      },
      resetFormData() {
        this.selectedEntityData = '';
        this.sum_fields = [];
        this.pieChartField = '';
        this.pieChartFieldOptions = [];
        this.pieChartFieldGroupBy = '';
        this.pieChartFieldGroupBySelectedOptions = [];
        this.selectedEntityRelationalData = '';
        this.notifications = [];
        this.componentName = '';
        this.selectedRelationalFilter = 'login_user';
      },
      resetPieModel() {
        ((this.BarColor = ''), (this.chartType = ''));
        this.pieChartField = '';
        this.pieChartFieldOptions = [];
        this.pieChartFieldOptionsColors = [];
        this.chartSelectedFilter = '';
        this.chartComponentName = '';
        this.chartDescription = '';
        this.isCustomization = false;
        this.combinedData = [];
        this.isStacked = false;
        this.startFrom = false;
        this.selectedCustomization = '';
        ((this.date_filter_field = ''), (this.rows = [{ sum_field: null, chart_type: null }]));
      },
      insertFilterComponent() {
        // const fields = this.getTemplateFields.filter(
        //   e => this.customFilterField.indexOf(e.key) !== -1
        // );
        if (!this.customDashboardData.allStatComponents?.length) {
          this.$message.warning('There are no stats to display. Please add stats.');
          return;
        }
        let existedCustomFilters =
          this.customDashboardData.allCustomFilters.filter(
            (e) =>
              e.entity_id == this.selectedEntityData ||
              e.entity_id === this.selectedEntityRelationalData
          ) || [];
        if (existedCustomFilters && existedCustomFilters.length) {
          existedCustomFilters.forEach((e) => {
            if (this.customFilterField.indexOf(e.filter_field) === -1) {
              let removeIndex = this.customDashboardData.allCustomFilters.findIndex(
                (el) =>
                  (el.entity_id == this.selectedEntityData ||
                    el.entity_id == this.selectedEntityRelationalData) &&
                  el.filter_field == e.filter_field
              );
              this.removeFilterComponent(removeIndex);
            }
          });
        }
        this.customFilterField.forEach((e) => {
          let existedComponent = this.customDashboardData.allCustomFilters.find((j) => {
            if (j.entity_id == this.selectedEntityData && j.filter_field == e) {
              return j;
            }
          });
          if (!existedComponent) {
            let fieldType = this.getTemplateFields.find((field) => field.key === e);
            this.customDashboardData.allCustomFilters.push({
              component_name: '',
              entity_id:
                this.isEntityDashboard && this.selectedEntityRelationalData
                  ? this.selectedEntityRelationalData
                  : this.selectedEntityData,
              filter_id: '',
              type: 'CUSTOM_FILTER',
              feature: 'ENTITY',
              icon: 'dashboard.svg',
              filter_field: e,
              filter_field_type: fieldType.inputType,
              filter_field_entity_id: fieldType.entity_id,
              selected_filter: '',
              keyValue: this.getRandomKey(),
              is_relational_data:
                this.isEntityDashboard &&
                this.getRelationshipEntities.filter((e) => e._id == fieldType.entity_id).length
                  ? true
                  : false,
            });
          }
        });
        bus.$emit('apply-custom-filter', {
          reset: true,
        });
        // this.resetFilterModal();
      },
      insertMulCustomFilter() {
        const filterFieldEntityId = this.multipleCustomFilterField.split('-')[0];
        let existingFilters = this.customDashboardData.allMulCustomFilters.filter(
          (filter) => filter.filter_field_entity_id === filterFieldEntityId
        );

        if (existingFilters.length) {
          existingFilters.forEach((filter) => {
            filter.entities.forEach((entity, index) => {
              if (this.selectedMulCustomFilterEntity.indexOf(entity.entity_id) === -1) {
                filter.entities.splice(index, 1);
              }
            });

            if (filter.entities.length === 0 || this.selectedMulCustomFilterEntity.length === 0) {
              const removeIndex = this.customDashboardData.allMulCustomFilters.findIndex(
                (f) => f.filter_field_entity_id === filterFieldEntityId
              );

              this.customDashboardData.allMulCustomFilters.splice(removeIndex, 1);
            }
          });
        }

        let existingComponent = this.customDashboardData.allMulCustomFilters.find(
          (filter) => filter.filter_field_entity_id === filterFieldEntityId
        );
        if (!existingComponent) {
          const entityIds = this.selectedMulCustomFilterEntity;
          const filterFields = this.orderedMatchingFieldKeys;
          const combinedArray = [];
          for (let i = 0; i < entityIds.length; i++) {
            combinedArray.push({
              entity_id: entityIds[i],
              filter_field: filterFields[i],
            });
          }
          if (combinedArray.length > 0) {
            this.customDashboardData.allMulCustomFilters.push({
              component_name: '',
              entities: combinedArray,
              filter_id: '',
              type: 'MULTIPLE_CUSTOM_FILTER',
              feature: 'ENTITY',
              icon: 'dashboard.svg',
              filter_field_type: '',
              filter_field_entity_id: filterFieldEntityId,
              selected_filter: '',
              keyValue: this.getRandomKey(),
              multiple_filter_dependency: this.multipleFilterDependency,
            });
          }
        } else {
          this.selectedMulCustomFilterEntity.forEach((entityId) => {
            const alreadyExists = existingComponent.entities.some(
              (entity) => entity.entity_id === entityId
            );
            if (!alreadyExists) {
              existingComponent.entities.push({
                entity_id: entityId,
                multiple_filter_dependency: this.multipleFilterDependency,
                filter_field:
                  this.orderedMatchingFieldKeys[
                    this.selectedMulCustomFilterEntity.indexOf(entityId)
                  ],
              });
            }
          });
        }
        this.multipleCustomFilterField = '';
        this.selectedMulCustomFilterEntity = [];
        this.matchingFieldKeys = [];
        this.orderedMatchingFieldKeys = [];
        this.multipleFilterDependency = '';
      },
      resetFilterModal() {
        this.customFilterField = [];
      },
      removeFilterComponent(index) {
        this.customDashboardData.allCustomFilters.splice(index, 1);
      },
      insertCardComponent() {
        let existedEntityFilters =
          this.customDashboardData.allTableComponents.filter(
            (e) => e.entity_id == this.selectedEntityData
          ) || [];
        if (existedEntityFilters && existedEntityFilters.length) {
          existedEntityFilters.forEach((e) => {
            if (this.selectedFilter.indexOf(e.filter_id) === -1) {
              let removeIndex = this.customDashboardData.allTableComponents.findIndex(
                (el) => el.entity_id == this.selectedEntityData && el.filter_id == e.filter_id
              );
              this.deleteComponent(removeIndex);
            }
          });
        }
        if (this.selectedFilter && this.selectedFilter.length) {
          this.selectedFilter.forEach((filter) => {
            let existedComponent = this.customDashboardData.allTableComponents.find((j) => {
              if (j.entity_id == this.selectedEntityData && j.filter_id == filter) {
                return j;
              }
            });
            if (!existedComponent) {
              let selectedEntity = this.getAllEntitiesData.find(
                (e) => e._id == this.selectedEntityData
              );
              let selectedEntityFilter = this.filters.find((e) => e._id == filter);
              let name = '';
              if (selectedEntity && selectedEntity.name) {
                name = selectedEntity.name;
                if (selectedEntityFilter && selectedEntityFilter.filter_name) {
                  name = name + ' ' + selectedEntityFilter.filter_name;
                }
              }
              let components = {
                component_name: name,
                entity_id: this.selectedEntityData,
                filter_id: filter,
                type: 'CARD',
                feature: 'ENTITY',
                icon: 'dashboard.svg',
                keyValue: this.getRandomKey(),
                order: this.customDashboardData.allTableComponents.length,
              };
              this.customDashboardData.allTableComponents.push(components);
            }
          });
        } else {
          let selectedEntity = this.getAllEntitiesData.find(
            (e) => e._id == this.selectedEntityData
          );
          let name = '';
          if (selectedEntity && selectedEntity.name) {
            name = selectedEntity.name;
          }
          let components = {
            component_name: name,
            entity_id: this.selectedEntityData,
            type: 'CARD',
            feature: 'ENTITY',
            icon: 'dashboard.svg',
            keyValue: this.getRandomKey(),
            self_entity: true,
            order: this.customDashboardData.allTableComponents.length,
          };
          this.customDashboardData.allTableComponents.push(components);
        }
      },
      insertTableComponent() {
        let entity_id = '';
        let is_relational_data =
          this.isEntityDashboard && this.selectedEntityRelationalData ? true : false;
        this.selectedFilter = this.selectedFilter.filter((e) => e);
        if (this.isEntityDashboard && this.selectedEntityRelationalData) {
          entity_id = this.selectedEntityRelationalData;
          is_relational_data = true;
        } else {
          entity_id = this.selectedEntityData;
        }
        let existedEntityFilters =
          this.customDashboardData.allTableComponents.filter(
            (e) =>
              e.type == 'TABLE' &&
              e.entity_id == entity_id &&
              ((!e.is_relational_data && !is_relational_data) ||
                is_relational_data == e.is_relational_data)
          ) || [];
        if (existedEntityFilters && existedEntityFilters.length) {
          existedEntityFilters.forEach((e) => {
            if (this.selectedFilter.length && this.selectedFilter.indexOf(e.filter_id) === -1) {
              let removeIndex = this.customDashboardData.allTableComponents.findIndex(
                (el) =>
                  el.type == 'TABLE' &&
                  el.filter_id &&
                  el.entity_id == entity_id &&
                  el.filter_id == e.filter_id &&
                  ((!el.is_relational_data && !is_relational_data) ||
                    is_relational_data == el.is_relational_data)
              );
              if (removeIndex > -1) {
                this.deleteComponent(removeIndex);
              }
            }
          });
        }
        if (this.selectedFilter && this.selectedFilter.length) {
          this.selectedFilter.forEach((filter) => {
            let existedComponent = this.customDashboardData.allTableComponents.find((j) => {
              if (
                !j.table_field_group_by &&
                j.type == 'TABLE' &&
                j.entity_id == entity_id &&
                j.filter_id == filter &&
                ((!j.is_relational_data && !is_relational_data) ||
                  is_relational_data == j.is_relational_data)
              ) {
                return j;
              }
            });
            if (!existedComponent || this.tableFieldGroupBy) {
              let selectedEntity = this.getAllEntitiesData.find(
                (e) => e._id == this.selectedEntityData
              );
              let selectedEntityFilter = this.filters.find((e) => e._id == filter);
              let name = '';
              if (selectedEntity && selectedEntity.name) {
                name = selectedEntity.name;
                if (selectedEntityFilter && selectedEntityFilter.filter_name) {
                  name = name + ' ' + selectedEntityFilter.filter_name;
                }
              }
              let components = {
                component_name: name,
                entity_id: entity_id,
                filter_id: filter,
                type: 'TABLE',
                feature: 'ENTITY',
                icon: 'dashboard.svg',
                keyValue: this.getRandomKey(),
                isExpandTable: this.customDashboardData.allTableComponents.isExpandTable,
                order: this.customDashboardData.allTableComponents.length,
                is_relational_data:
                  this.isEntityDashboard && this.selectedEntityRelationalData ? true : false,
                table_field_group_by: this.tableFieldGroupBy,
                table_field_sub_group_by: this.tableFieldSubGroupBy,
                table_field_group_by_fields: this.tableFieldGroupByFields,
                table_field_group_by_selected_options: this.tableFieldGroupBySelectedOptions,
                send_notification: false,
                ShowExport: this.ShowExport,
                date_filter_field: this.date_filter_field,
                selectedRelationalFilter: this.customDashboardData.selectedRelationalFilter,
              };
              this.customDashboardData.allTableComponents.push(components);
            }
          });
        } else {
          let selectedEntity = this.getAllEntitiesData.find((e) => e._id == entity_id);
          let name = '';
          if (selectedEntity && selectedEntity.name && is_relational_data) {
            name = 'My ' + selectedEntity.name;
          }
          let components = {
            component_name: name,
            entity_id: entity_id,
            type: 'TABLE',
            feature: 'ENTITY',
            icon: 'dashboard.svg',
            keyValue: this.getRandomKey(),
            self_entity: true,
            isExpandTable: false,
            order: this.customDashboardData.allTableComponents.length,
            is_relational_data: is_relational_data,
            table_field_group_by: this.tableFieldGroupBy,
            table_field_sub_group_by: this.tableFieldSubGroupBy,
            table_field_group_by_fields: this.tableFieldGroupByFields,
            table_field_group_by_selected_options: this.tableFieldGroupBySelectedOptions,
            ShowExport: this.ShowExport,
            send_notification: false,
            date_filter_field: this.date_filter_field,
            selectedRelationalFilter: this.customDashboardData.selectedRelationalFilter,
          };
          this.customDashboardData.allTableComponents.push(components);
        }
        this.resetTableComponentData();
      },
      resetTableComponentData() {
        this.tableFieldGroupBy = '';
        this.tableFieldSubGroupBy = '';
        this.tableFieldGroupBySelectedOptions = [];
        this.tableFieldGroupByFields = [
          {
            key: 'count',
            name: 'Count',
            type: 'count',
            sub_group: false,
          },
        ];
        this.selectedEntityData = [];
        this.date_filter_field = '';
        this.ShowExport = false;
      },
      getComponentInfo() {
        if (this.selectedComponentType == 'CHART' || this.selectedComponentType == 'CALENDAR') {
          this.fetchTemplateFields(true);
        } else if (
          this.selectedComponentType == 'CUSTOM_FILTER' ||
          this.selectedComponentType == 'TABLE'
        ) {
          this.fetchTemplateFields(false);
        } else if (this.selectedComponentType == 'MULTIPLE_CUSTOM_FILTER') {
          this.handleFieldChange();
        } else {
          this.fetchAllEntityFilters(this.selectedEntityData);
        }
      },
      fetchTemplateFields(isChart) {
        if (!this.selectedEntityData && !this.selectedEntityRelationalData) {
          return;
        }
        let id = this.selectedEntityData
          ? this.selectedEntityData
          : this.selectedEntityRelationalData;
        this.fetchAllEntityFilters(id);
        let entity = this.getAllEntitiesData.find((e) => e._id == id);
        if (!entity) {
          entity = this.getRelationshipEntities.find((e) => e._id == id);
        }
        if (isChart) {
          this.pieChartField = '';
        }
        const templateIds = (entity.templates || [])
          .filter((e) => !e.is_repeatable)
          .flatMap((e) => e.template_id);
        const entityTemplates = this.allTemplates.filter((e) => templateIds.indexOf(e._id) !== -1);
        this.getTemplateFields = [];
        this.getTotalFields = [];
        this.getAllDateFields = [];
        entityTemplates.forEach((e) => {
          let data = JSON.parse(JSON.stringify(e));
          let data1 = JSON.parse(JSON.stringify(e));
          let customization =
            entity.templates.find((t) => t.template_id == e._id)?.customization || {};
          if (customization) {
            data.sections[0].fields = this.applyCustomizationOnFields(
              data.sections[0].fields,
              customization
            );
            data1.sections[0].fields = this.applyCustomizationOnFields(
              data1.sections[0].fields,
              customization
            );
          }
          this.getAllDateFields = [
            ...this.getAllDateFields,
            ...this.getTemplateFieldsByType(data1, ['DATE', 'DATE_TIME', 'DATE_RANGE']),
          ];
          this.getTemplateFields = [
            ...this.getTemplateFields,
            ...this.getTemplateFieldsByType(
              data,
              isChart
                ? [
                    'SELECT',
                    'YES_OR_NO',
                    'MULTI_SELECT',
                    'ENTITY',
                    'DATE',
                    'WEEKDAYS',
                    // "DATE_TIME",
                  ]
                : ['SELECT', 'ENTITY', 'MULTI_SELECT', 'DATE', 'YES_OR_NO']
            ),
          ];
          this.getTotalFields = [
            ...this.getTotalFields,
            ...this.getTemplateFieldsByType(data, [
              'NUMBER',
              'CURRENCY',
              'FORMULA',
              'AGGREGATE_FUNCTION',
            ]),
          ];
        });
        this.customFilterField = this.customDashboardData.allCustomFilters
          .filter(
            (e) =>
              e.entity_id === this.selectedEntityData ||
              e.entity_id === this.selectedEntityRelationalData
          )
          .flatMap((e) => e.filter_field);
      },
      async fetchAllEntityFilters(entityId) {
        if (!entityId) {
          return;
        }
        this.chartFilters = [];
        this.loading = true;
        await this.$store.dispatch('filters/fetchAllEntityFilters', {
          entityId: entityId,
        });
        if (this.addStatsModal) {
          this.statEntityFilters = [];
          if (this.getAllEntityFilters) {
            this.statEntityFilters = [...this.getAllEntityFilters];
          }
        } else {
          this.filters = [];
          this.selectedFilter = [];
          if (this.getAllEntityFilters) {
            this.filters = this.getAllEntityFilters;
            this.entityFilterObject[entityId] = this.getAllEntityFilters;
            let entity_id = '';
            let is_relational_data =
              this.isEntityDashboard && this.selectedEntityRelationalData ? true : false;
            this.selectedFilter = this.selectedFilter.filter((e) => e);
            if (this.isEntityDashboard && this.selectedEntityRelationalData) {
              entity_id = this.selectedEntityRelationalData;
            } else {
              entity_id = this.selectedEntityData;
            }
            let existedFilters = this.customDashboardData.allTableComponents.filter(
              (u) => u.entity_id == entity_id && u.is_relational_data == is_relational_data
            );
            this.selectedFilter =
              existedFilters && existedFilters.length ? existedFilters.map((e) => e.filter_id) : [];
          }
        }
        this.chartFilters = this.getAllEntityFilters;
        this.loading = false;
      },
      async getNecessaryInfo() {
        this.loading = true;
        this.loadingText = 'Fetching dashboard data...';
        let promises = [
          this.fetchAllEntities(false),
          this.fetchAllTemplates(true),
          fetchGlobalVariables({
            get_all: true,
          }),
          fetchEntityViews({ get_all: true }),
          this.getIntegrations(),
          await this.$store.dispatch('applicationUsersPermission/fetchAllPermissionsEntityById', {
            id: this.$route.params.entityId,
          }),
        ];
        // const query = { get_all: true };
        if (this.isEntityDashboard) {
          if (this.$route.query.dashboardId) {
            await this.$store.dispatch(
              'customDashboard/getDashboardById',
              this.$route.query.dashboardId
            );
          } else {
            this.$store.commit('customDashboard/setSingleDashboardData', null, {
              root: true,
            });
          }
          if (this.role_id) {
            let selectedPermission = this.getAllEntityPermissions.find(
              (role) => role.role_id === this.role_id
            );
            this.$store.commit(
              'applicationUsersPermission/setEntityPermission',
              selectedPermission
            );
          } else {
            await Promise.all([
              this.$store.dispatch('applicationUsersPermission/fetchPermissionsEntityById', {
                id: this.$route.params.entityId,
              }),
            ]);
          }
          promises.push(
            fetchEntityRelationships({
              entity_id: this.$route.params.entityId,
            })
          );
        } else {
          const response = await this.$store.dispatch(
            'customDashboard/getDashboardById',
            this.$route.params.dashboardId
          );
          const icons = [];
          const allComponents = response?.components;
          if (Array.isArray(allComponents)) {
            allComponents.forEach((item) => {
              if (item.icon) {
                icons.push(item.icon);
              }
            });
          }
          const iconKeys = await getIconKeysFromMasterIcons(icons);
          const key = this.getActiveWorkspace.company_id + ':custom-dashboard';
          await createIcons(key, iconKeys);
        }
        // let params = { get_all: true, include_standard: true, populate_data: true };
        let [
          entities,
          templates,
          globalVariables,
          entityViews,
          integrations,
          fetchedEntityRelationships,
        ] = await Promise.all(promises);
        if (templates) {
          this.allTemplates = templates;
        }
        if (entities) {
          this.getAllEntities = {
            data: entities,
          };
        }
        if (templates?.data) {
          this.allTemplates = templates.data;
        }
        if (entities?.data) {
          this.getAllEntities = { ...entities };
        }
        if (globalVariables && globalVariables.data) {
          this.globalVariablesData = [...globalVariables.data];
        }
        if (entityViews?.data) {
          this.getAllEntityViews = { ...entityViews };
        }
        if (integrations) {
          this.integrations = integrations;
        }
        // let response = await axios.get("template/list", {
        //   params,
        // });
        // this.getAllCompanyTemplatesData = { ...response.data };
        if (this.getEntityPermission?._id) {
          this.setPermittedEntities();
        }
        if (this.isEntityDashboard && this.getAllEntities) {
          this.currentEntity = (this.getAllEntities.data || []).find(
            (e) => e._id == this.$route.params.entityId
          );
          this.currentEntityFields = await this.fetchEntityDetails(
            this.$route.params.entityId,
            true,
            false,
            false,
            false,
            true,
            true
          );
        }
        if (fetchedEntityRelationships && this.$route.params.entityId) {
          this.setRelationshipPermissions(this.$route.params.entityId);
        }
        if (this.getSingleDashboardData) {
          this.setData(this.getSingleDashboardData);
          if (!this.isEntityDashboard) {
            updateCustomDashboardData(this.getSingleDashboardData._id, this.getSingleDashboardData);
          }
        } else {
          if (this.isEntityDashboard && this.getAllEntities) {
            // let selectedEntity = (this.getAllEntities.data || []).find(
            //   (e) => e._id == this.$route.params.entityId
            // );
            if (this.currentEntity?.name) {
              this.customDashboardData.name = this.currentEntity.name + ' Dashboard';
            }
          }
        }
        this.loading = false;
      },
      setRelationshipPermissions(id) {
        this.getEntityRelationships.forEach((el) => {
          if (el?.child_entity_id !== id) {
            this.relationshipEntities.push(el.child_entity_id);
          } else if (this.selectedEntityId !== id) {
            this.relationshipEntities.push(el.parent_entity_id);
          }
        });
      },
      setPermittedEntities() {
        this.permittedEntities = [];
        this.permittedRelatedEntities = [];
        this.permittedNestedRelatedEntities = [];
        if (this.getEntityPermission?.other_entities) {
          Object.keys(this.getEntityPermission?.other_entities).forEach((e) => {
            if (
              this.getEntityPermission?.other_entities[e].permissions &&
              this.getEntityPermission?.other_entities[e].permissions.indexOf('VIEW') != -1
            ) {
              this.permittedEntities.push(e);
            }
          });
        }
        if (this.getEntityPermission?.relational_entities) {
          Object.keys(this.getEntityPermission?.relational_entities).forEach((e) => {
            if (
              this.getEntityPermission?.relational_entities[e].permissions &&
              this.getEntityPermission?.relational_entities[e].permissions.indexOf('VIEW') != -1
            ) {
              this.permittedRelatedEntities.push(e);
            }
          });
        }
        if (this.getEntityPermission?.nested_relational_entities) {
          Object.keys(this.getEntityPermission?.nested_relational_entities).forEach((e) => {
            if (
              this.getEntityPermission?.nested_relational_entities[e].permissions &&
              this.getEntityPermission?.nested_relational_entities[e].permissions.indexOf('VIEW') !=
                -1
            ) {
              this.permittedNestedRelatedEntities.push(e);
            }
          });
        }
      },
      setData(data) {
        this.customDashboardData.name = data.name;
        this.customDashboardData.includeGlobalDateFilter = data.include_global_date_filter;
        this.customDashboardData.selectedRelationalFilter =
          data.selectedRelationalFilter || 'login_user';
        this.customDashboardData.date_value = data.date_value;
        this.customDashboardData.Custom_date_value = data.Custom_date_value;
        this.customDashboardData.allowUserChangeOrder = data.allow_user_change_order;
        this.customDashboardData.allCustomFilters = data.components
          .filter((e) => e.type == 'CUSTOM_FILTER')
          .map((e) => {
            e.value = '';
            e.selected_filter = '';
            if (e.selected_date_picker) {
              e.selected_date_picker = '';
            }
            e.keyValue = this.getRandomKey();
            return e;
          });
        this.customDashboardData.allMulCustomFilters = data.components
          .filter((e) => e.type == 'MULTIPLE_CUSTOM_FILTER')
          .map((e) => {
            e.value = '';
            e.selected_filter = '';
            if (e.selected_date_picker) {
              e.selected_date_picker = '';
            }
            // e.keyValue = this.getRandomKey();
            return e;
          });
        // this.customDashboardData.allIntegrationFilters = data.components.filter(
        //   (e) => e.type == "INTEGRATION_FILTER"
        // );
        this.customDashboardData.allTableComponents = [];
        let allMainComponents = data.components
          .filter((e) =>
            [
              'TABLE',
              'CHART',
              'CALENDAR',
              'LOGINS',
              'ATTENDANCE',
              'ENTITY_VIEW',
              'GAUGE_CHART',
              'NOTIFICATIONS',
              'SCHEDULING',
              // "GANTT_CHART",
            ].includes(e.type)
          )
          .map((e) => {
            e.customFilers = this.customDashboardData.allCustomFilters
              .filter((el) => el.entity_id === e.entity_id && el.selected_filter)
              .map((fl) => {
                fl.field = fl.filter_field;
                fl.value = fl.selected_filter;
                fl.operator = '=case-insensitive';
                fl.query_type = 'AND';
                fl.data_type = 'STRING';
                return fl;
              });
            e.keyValue = this.getRandomKey();
            return e;
          });
        allMainComponents = allMainComponents.filter((e) => {
          if (e.type == 'TABLE' && (!e.entity_id || !e.entity_id.length)) {
            return false;
          }
          return true;
        });
        this.customDashboardData.allTableComponents = allMainComponents.sort((a, b) =>
          a.order < b.order ? -1 : 1
        );
        this.customDashboardData.allStatComponents = data.components
          .filter((e) => e.type == 'STAT')
          .map((e) => {
            e.customFilers = this.customDashboardData.allCustomFilters
              .filter((el) => el.entity_id === e.entity_id && el.selected_filter)
              .map((fl) => {
                fl.field = fl.filter_field;
                fl.value = fl.selected_filter;
                fl.operator = '=case-insensitive';
                fl.query_type = 'AND';
                fl.data_type = 'STRING';
                return fl;
              });
            if (!e.keyValue) {
              e.keyValue = this.getRandomKey();
            }
            return e;
          });
        (this.customDashboardData.allTableComponents || []).forEach((el, i) => {
          if (el.type == 'CALENDAR' && el.calenderDateField) {
            el.calenderDateField.forEach((field) => {
              this.getEntityFilters(field.field);
            });
          }
          if (el.is_expand) {
            this.expendedIndexs.push(i);
          }
        });
        this.rawData = JSON.parse(JSON.stringify({ ...this.customDashboardData }));
      },
      searchFilters() {
        if (this.filterSearchString.length > 0) {
          const regex = new RegExp(this.filterSearchString, 'i');
          const matchedFilters = (this.getAllEntityFilters || []).filter(({ filter_name }) =>
            filter_name.match(regex)
          );
          this.filters = [...[], ...matchedFilters];
        } else {
          this.filters = [...[], ...(this.getAllEntityFilters || [])];
        }
      },
      getComponentStatus() {
        this.$notify({
          title: 'Success',
          message: 'Component saved successfully',
          type: 'success',
        });
      },
      goBackSave() {
        if (JSON.stringify(this.rawData) !== JSON.stringify(this.customDashboardData)) {
          this.$router.push({ path: '/custom/dashboard-list' });
        } else {
          if (this.$route.params.entityId) {
            this.$router.push({ path: '/entity' });
            // If there is Entity ID in the route then return to entities list
          } else {
            // if there is no Entity ID then return to custom dashboards list screen
            this.$router.push({ path: '/custom/dashboard-list' });
          }
        }
      },

      goBack() {
        if (this.isEntityDashboard) {
          if (this.$route.params.role_id) {
            this.$router.push(
              `/ap-user/custom-dashboards/${this.$route.params.entityId}/rbac?name=${this.$route.query.name}`
            );
            return;
          } else {
            this.$router.push(
              `/ap-user/custom-dashboards/${this.$route.params.entityId}?name=${this.$route.query.name}`
            );
          }
        } else {
          if (this.checkUrlType() == 'private') {
            this.$router.push(`/if/${this.getAuthenticatedSSOToken}private/custom/dashboard-list`);
          } else {
            this.$router.push({ path: '/custom/dashboard-list' });
          }
        }
      },
      displayChartsPopup() {
        if (this.customDashboardData.isFromIntegrations) {
          this.thirdPartyChartsDialogVisible = true;
        } else {
          this.centerChartsDialogVisible = true;
        }
      },
      closeIntgerationsPopup() {
        this.thirdPartyChartsDialogVisible = false;
        this.integrationComponent = {
          component_name: '',
          type: 'CHART',
          chart_type: '',
          feature: 'ENTITY',
          isNew: true,
          date_filter_field: '',
          ignore_year: false,
          selected_fields: [],
          send_notification: false,
          compare: false,
          sort_by: '',
          sort_order: 'asc',
          compare_with: 'one',
          data_source: 'INTEGRATIONS',
          integrationsSettings: {
            integration_id: '',
            event: null,
            event_id: '',
            dependencies: {},
            selectedFields: [],
            globalFilters: [],
            exisitingFilterComponent: '',
            radioFilter: '1',
          },
          BarColor: this.BarColor,
        };
      },
      updateChartComponent(component) {
        this.selectedComponentType = 'CHART';
        this.customDashboardData.isFromIntegrations = true;
        this.integrationComponent = component;
        this.thirdPartyChartsDialogVisible = true;
      },
      addRow() {
        this.combinedData = this.rows;
        this.rows.push({ sum_field: null, chart_type: null });
      },
      removeRow(index) {
        if (this.rows.length > 1) {
          this.rows.splice(index, 1);
        }
      },
      isOptionDisabled(selectedField, fieldKey, rowIndex) {
        for (let i = 0; i < rowIndex; i++) {
          if (this.rows[i].sum_field === fieldKey) {
            return true;
          }
        }
        return false;
      },
      chartsPopUpClose() {
        this.chartType = '';
        this.centerChartsDialogVisible = false;
      },
      saveChartData() {
        if (this.rows[0].sum_field != null) {
          this.combinedData = this.rows;
        }
        let ex = this.customDashboardData.allTableComponents.filter(
          (e, i) =>
            i !== this.index &&
            e.component_name.toLowerCase() == this.chartComponentName.toLowerCase()
        );
        if (ex && ex.length) {
          this.$notify.error({
            title: 'Error',
            message: 'Component name already exists',
          });
          return;
        } else {
          if (this.customDashboardData.isFromIntegrations) {
            this.thirdPartyChartsDialogVisible = false;
          } else {
            this.centerChartsDialogVisible = false;
          }
          this.insertComponent();
        }
      },
      getEntityDateFromFields() {
        let entities = this.getCurrentEntitiesData;
        const matchingEntities = [];
        const templateFields = [];
        entities.forEach((entityObject) => {
          const id = entityObject._id;
          let entity = this.getAllEntitiesData.find((e) => e._id === id);
          if (!entity) {
            entity = this.getRelationshipEntities.find((e) => e._id === id);
          }

          const templateIds = (entity.templates || [])
            .filter((e) => !e.is_repeatable)
            .map((e) => e.template_id);

          const entityTemplates = this.allTemplates.filter((e) => templateIds.includes(e._id));

          entityTemplates.forEach((e) => {
            const data = JSON.parse(JSON.stringify(e));
            const fieldTypes = ['ENTITY'];
            const fields = this.getTemplateFieldsByType(data, fieldTypes);
            const filteredFields = fields.filter((field) => field.inputType === 'ENTITY');
            templateFields.push(...filteredFields);
            const matchingFields = filteredFields.filter((field) => {
              if (this.multipleCustomFilterField.length) {
                const isMatching = field.entity_id === this.multipleCustomFilterField.split('-')[0];
                if (isMatching) {
                  this.matchingFieldKeys.push({ [entityObject._id]: field.key });
                }
                return isMatching;
              }
            });
            if (matchingFields.length > 0) {
              matchingEntities.push(entityObject);
            }
          });
        });

        this.customDashboardData.allMulCustomFilters.forEach((filter) => {
          if (this.multipleCustomFilterField.length) {
            if (filter.filter_field_entity_id === this.multipleCustomFilterField.split('-')[0]) {
              filter.entities.forEach((entity) => {
                if (!this.selectedMulCustomFilterEntity.includes(entity.entity_id)) {
                  this.selectedMulCustomFilterEntity.push(entity.entity_id);
                }
              });
            }
          }
        });
        this.matchingFieldKeys = [...new Set(this.matchingFieldKeys)];
        return matchingEntities;
      },
      handleFieldChange() {
        this.selectedMulCustomFilterEntity = [];
        this.entityOptions = this.getEntityDateFromFields();
        if (this.multipleCustomFilterField) {
          this.buildFilterDependencies();
        }
      },
      async buildFilterDependencies() {
        /* Mixins */
        let entityId = this.multipleCustomFilterField.split('-')[0];
        await this.fetchRelationships(entityId);
        let relationships = this.relationshipData[entityId];
        this.setDependencies(entityId, relationships, this.customDashboardData.allMulCustomFilters);
      },
      setDependencies(entityId, relationships, components) {
        this.multipleFilterDependencies = [];
        components.map((component) => {
          let relationship = relationships.find(
            (rl) =>
              component.filter_field_entity_id != entityId &&
              (component.filter_field_entity_id == rl.parent_entity_id ||
                component.filter_field_entity_id == rl.child_entity_id)
          );
          if (relationship) {
            let entity = this.getAllEntitiesData.find(
              (e) => e._id == component.filter_field_entity_id
            );
            if (!entity) {
              entity = this.getRelationshipEntities.find(
                (e) => e._id == component.filter_field_entity_id
              );
            }
            this.multipleFilterDependencies.push({
              label: entity.name,
              key: component.keyValue,
            });
            console.log('this.multipleFilterDependencies', this.multipleFilterDependencies);
          }
        });
      },
      updateMatchingFieldKeys() {
        const entityToKeyMap = this.matchingFieldKeys.reduce((acc, item) => {
          const [entityId, key] = Object.entries(item)[0];
          acc[entityId] = key;
          return acc;
        }, {});
        this.orderedMatchingFieldKeys = this.selectedMulCustomFilterEntity
          .map((entityId) => entityToKeyMap[entityId])
          .filter((key) => key !== undefined);
      },
      updateDateFilter(value) {
        this.customDashboardData['date_value'] = value;
      },
      updateCustomDateFilter(value) {
        this.customDashboardData['Custom_date_value'] = value;
      },
      DateFilterUpdate() {
        this.dateFilter = true;
      },
      updateDashboardStats(updatedStats) {
        this.customDashboardData.allStatComponents = updatedStats;
      },
      async getEpicenter(address) {
        try {
          // These are query Params to make API call
          const config = {
            params: {
              address: address,
              sensor: true,
              key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
            },
          };

          const response = await axios.get(
            'https://maps.googleapis.com/maps/api/geocode/json',
            config
          );

          const coordinates = response.data.results[0].geometry.location;
          this.geoFenceCoordinates = [coordinates.lat, coordinates.lng];
          this.$set(this.geoFenceCoordinates, `${this.coordinates[0]}, ${this.coordinates[1]}`);
        } catch (error) {
          console.error('getCoordinates', error);
          return null;
        }
      },
    },
  };
</script>
<style lang="scss">
  .scrollbar-container {
    height: 50vh;
    overflow-y: auto;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 10px;
    width: 100% !important;
  }

  .left-side-menu {
    height: 100vh;
    padding: 5px;
    border-right: 1px solid #f2f2f2;
  }

  .side-menu {
    padding-top: 10px;
    padding-left: 10px;
  }

  .row {
    padding: 5px 20px;
    background-color: var(--brand-500);
    color: var(--primary-contrast-color);
  }

  .checkboxOrder {
    display: inline-flex;
    flex-direction: column;
  }

  .nodata-stat-root {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    color: #9f9f9f;
    cursor: pointer;
    text-align: center;
  }

  .all-table-body {
    word-wrap: break-word;
  }

  .drag-grid {
    display: grid !important;
    grid-template-columns: 50% 50% !important;
    gap: 10px !important;
    padding: 25px;
  }

  .el-button--primary {
    color: var(--primary-contrast-color);
    background-color: var(--brand-500);

    &:hover {
      color: var(--brand-500);
      background-color: var(--primary-contrast-color);
      border-color: var(--brand-500);
    }
  }
</style>
<style scoped>
  .ai-icon-content {
    display: flex;
    min-width: 115px;
    align-items: center;
    color: var(--brand-500);
    cursor: pointer;
  }

  .try-ai-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }

  .el-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    padding: 8px 20px !important;
    font-size: 14px;
    border-radius: 4px;
  }

  .el-button--primary.is-disabled {
    color: #fff;
    background-color: #bebebe;
    border-color: #bebebe;
  }

  .custom-dashboard-view {
    overflow: hidden;
    max-height: 100vh;
    max-width: 100vw;
  }

  .configuration-cards {
    max-height: calc(100vh - 70px);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }

  .flex-container {
    display: flex;
    align-items: center;
  }

  .flex-item {
    margin-right: 10px;
  }

  .red-asterisk {
    color: red !important;
  }

  .el-button--success {
    color: var(--primary-contrast-color);
    background: var(--primary-color-brand);
    border: var(--primary-color-brand);
  }

  .el-button--success.is-disabled {
    color: #fff;
    background-color: #bebebe;
    border-color: #bebebe;
  }

  .saveBtnSty {
    position: relative;
    right: 25px;
  }
</style>
<style scoped>
  ::v-deep(.chart-component-sty .dialog-content) {
    scrollbar-width: none;
    overflow-y: hidden;
  }

  ::v-deep(.chart-component-sty .scrollable-content) {
    max-height: 82vh !important;
  }
</style>
